import React, { Component } from "react";

export default class AndroidImg extends Component {
  render() {
    const { theme, ...svgProps } = this.props;
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" {...svgProps}>
    <g id="freepik--Floor--inject-435">
      <ellipse
        id="freepik--floor--inject-435"
        cx={250}
        cy={377.09}
        rx={220.52}
        ry={112.57}
        fill={theme.compImgHighlight}
      />
    </g>
    <g id="freepik--Shadows--inject-435">
      <path
        id="freepik--Shadow--inject-435"
        d="M144.39,451.45,50.55,397.28c-3.27-1.89-3.27-5,0-6.85l169.6-97.94a13.11,13.11,0,0,1,11.86,0l93.83,54.17c3.28,1.89,3.28,5,0,6.85L156.25,451.45A13.11,13.11,0,0,1,144.39,451.45Z"
        fill={theme.compImgHighlight}
      />
      <ellipse
        id="freepik--shadow--inject-435"
        cx={331.54}
        cy={395.71}
        rx={64.67}
        ry={37.34}
        fill={theme.compImgHighlight}
      />
    </g>
    <g id="freepik--Plant--inject-435">
      <g id="freepik--Plants--inject-435">
        <path
          d="M142.32,399.38s-2.27-22.05-8.69-36.33-16.7-24.12-27.29-26.55-20.7,6.14-10.24,14.6,28.51,19.8,34.13,46.51Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M142.32,399.38s-2.27-22.05-8.69-36.33-16.7-24.12-27.29-26.55-20.7,6.14-10.24,14.6,28.51,19.8,34.13,46.51Z"
          style={{
            opacity: 0.15,
          }}
        />
        <path
          d="M135.78,398.87a.45.45,0,0,1-.44-.43c-1.68-34.41-20.41-49.22-31.43-55a.45.45,0,0,1,.42-.79c11.18,5.86,30.19,20.89,31.9,55.74a.45.45,0,0,1-.42.47Z"
          fill={theme.compImgHighlight}
        />
        <path
          d="M96,379.27c-1,3.13,1.19,5.3,3.29,7.06,1.62,1.35,3.38,2.82,3.83,4.88.89,4.17-4,8-3,12.13a6.59,6.59,0,0,0,3.47,3.88,43.26,43.26,0,0,0,4.09,1.74,17.14,17.14,0,0,0,2.06.5,9.51,9.51,0,0,1,5.59,2.5c2.28,2.47,2,6.26,2.81,9.53l0,.11a10.07,10.07,0,0,0,15.6,5.5l11.51-8.2a15.44,15.44,0,0,0,1.9-13.75,12.24,12.24,0,0,0-3.94-5.79c-2.18-1.71-4.41-2.3-5.59-5.1a25.51,25.51,0,0,1-1.31-5.84,13.68,13.68,0,0,0-1.89-5.63,10.38,10.38,0,0,0-7.36-4c-3.33-.42-6.81,1-9.93-.16s-6.13-3-9.45-3.87c-3.62-.91-7.79-.42-10.5,2.51A5.43,5.43,0,0,0,96,379.27Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M129.72,397.68a.56.56,0,0,0-.14-.2c-8.56-12.12-22-17.87-26.51-18.88a.47.47,0,0,0-.56.36.48.48,0,0,0,.36.57c4.29,1,16.75,6.27,25.14,17.39a26.19,26.19,0,0,0-20.88,1.82.48.48,0,0,0-.14.66.5.5,0,0,0,.38.22.57.57,0,0,0,.28-.08,25.27,25.27,0,0,1,21.32-1.3,39.77,39.77,0,0,1,7.13,24.47.48.48,0,0,0,.42.49h0a.48.48,0,0,0,.49-.46A40.59,40.59,0,0,0,129.72,397.68Z"
          style={{
            fill: "#fff",
          }}
        />
      </g>
    </g>
    <g id="freepik--Gears--inject-435">
      <g id="freepik--gears--inject-435">
        <path
          d="M101,164.6h0a1,1,0,0,0-1,.13l-2,1.38-.36,1.19a2.23,2.23,0,0,0,.78,2.15,9.54,9.54,0,0,1,1.06,1,1.54,1.54,0,0,0,2,.31l4.64-3.23a1,1,0,0,1,1-.14Zm-6,17.09c-1-3.66-3.74-5.39-7-5a9.1,9.1,0,0,1,.88,2.13c1.64,5.81-1.6,14.3-7.21,19a12.09,12.09,0,0,1-6.08,2.9c2.34,3.84,7.38,4,12.23,0C93.33,196,96.56,187.5,94.92,181.69Zm-2.22-25h0a1.25,1.25,0,0,0-.4-.13l-3.78-.6a2,2,0,0,0-2,1l-2.92,6.32a2.77,2.77,0,0,1-.7.86h0a3.52,3.52,0,0,1-.56.39l1.4,3.32a1.34,1.34,0,0,0,1.82.65,19.9,19.9,0,0,1,2.22-.8A3.55,3.55,0,0,0,89,167a2.57,2.57,0,0,0,.71-.86l2.91-6.33a2,2,0,0,1,2-1l3.79.6a1.41,1.41,0,0,1,.38.11Zm-4.9,60.11a1,1,0,0,1-.4-.5l-1.61-3.8A1.35,1.35,0,0,0,84,211.8a18,18,0,0,1-2.22.8,2.62,2.62,0,0,0-.69.31l.21.49a1.06,1.06,0,0,0,.53.57h0ZM75.42,160.57a1.16,1.16,0,0,0-.42-.08,1.09,1.09,0,0,0-.66.28l-5.19,4.3a1.21,1.21,0,0,0-.19.2.65.65,0,0,0-.13.16,3,3,0,0,0-.42.83,1.17,1.17,0,0,1,0,.2h0a2.05,2.05,0,0,0-.06.84l.78,4.89a3.57,3.57,0,0,1-.64,2.41,39.25,39.25,0,0,0-2.29,3.28,2.59,2.59,0,0,1-1.14.93,2.7,2.7,0,0,1-.48.16.85.85,0,0,1-.23,0,1.12,1.12,0,0,1-.32,0H60.32l-.29,0-.26.07h0a1.69,1.69,0,0,0-.28.12,2.76,2.76,0,0,0-.49.32,2,2,0,0,0-.51.7l-2.71,7.13a1.33,1.33,0,0,0,.72,1.65L60.64,191a1.52,1.52,0,0,1,.18.95,27.8,27.8,0,0,0-.31,3.36,3.8,3.8,0,0,1-1,2.31l-.05,0L55,202.07a1.64,1.64,0,0,0-.21.25s0,0,0,.05a1.17,1.17,0,0,0-.17.31,2.42,2.42,0,0,0-.21,1.68l1.39,4.93a1.08,1.08,0,0,0,.5.66l6.12,2.84a1,1,0,0,1-.47-.64l-1.39-4.93a2.06,2.06,0,0,1,0-1,2.43,2.43,0,0,1,.65-1.33l4.48-4.37,0-.05a3.87,3.87,0,0,0,1-2.32,25.92,25.92,0,0,1,.31-3.35,1.73,1.73,0,0,0-1.16-1.8l-3-1a1.36,1.36,0,0,1-.92-1.73l2.71-7.13a1.91,1.91,0,0,1,.51-.7,2.28,2.28,0,0,1,1.44-.56h3.59a2.33,2.33,0,0,0,1-.23,2.54,2.54,0,0,0,1.14-.93c.71-1.13,1.48-2.23,2.29-3.28a3.53,3.53,0,0,0,.64-2.41l-.78-4.88a2,2,0,0,1,0-.86,2.66,2.66,0,0,1,.8-1.38l5.19-4.3a1,1,0,0,1,1.08-.2ZM71.92,213a2.26,2.26,0,0,0-.78-2.15,8.67,8.67,0,0,1-1.06-1,1.54,1.54,0,0,0-2-.33l-2.66,1.84-1.56,5.22a1.13,1.13,0,0,0,.62,1.37h0l6.16,2.87a1.15,1.15,0,0,1-.62-1.39Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M101,164.6h0a1,1,0,0,0-1,.13l-2,1.38-.36,1.19a2.23,2.23,0,0,0,.78,2.15,9.54,9.54,0,0,1,1.06,1,1.54,1.54,0,0,0,2,.31l4.64-3.23a1,1,0,0,1,1-.14Zm-6,17.09c-1-3.66-3.74-5.39-7-5a9.1,9.1,0,0,1,.88,2.13c1.64,5.81-1.6,14.3-7.21,19a12.09,12.09,0,0,1-6.08,2.9c2.34,3.84,7.38,4,12.23,0C93.33,196,96.56,187.5,94.92,181.69Zm-2.22-25h0a1.25,1.25,0,0,0-.4-.13l-3.78-.6a2,2,0,0,0-2,1l-2.92,6.32a2.77,2.77,0,0,1-.7.86h0a3.52,3.52,0,0,1-.56.39l1.4,3.32a1.34,1.34,0,0,0,1.82.65,19.9,19.9,0,0,1,2.22-.8A3.55,3.55,0,0,0,89,167a2.57,2.57,0,0,0,.71-.86l2.91-6.33a2,2,0,0,1,2-1l3.79.6a1.41,1.41,0,0,1,.38.11Zm-4.9,60.11a1,1,0,0,1-.4-.5l-1.61-3.8A1.35,1.35,0,0,0,84,211.8a18,18,0,0,1-2.22.8,2.62,2.62,0,0,0-.69.31l.21.49a1.06,1.06,0,0,0,.53.57h0ZM75.42,160.57a1.16,1.16,0,0,0-.42-.08,1.09,1.09,0,0,0-.66.28l-5.19,4.3a1.21,1.21,0,0,0-.19.2.65.65,0,0,0-.13.16,3,3,0,0,0-.42.83,1.17,1.17,0,0,1,0,.2h0a2.05,2.05,0,0,0-.06.84l.78,4.89a3.57,3.57,0,0,1-.64,2.41,39.25,39.25,0,0,0-2.29,3.28,2.59,2.59,0,0,1-1.14.93,2.7,2.7,0,0,1-.48.16.85.85,0,0,1-.23,0,1.12,1.12,0,0,1-.32,0H60.32l-.29,0-.26.07h0a1.69,1.69,0,0,0-.28.12,2.76,2.76,0,0,0-.49.32,2,2,0,0,0-.51.7l-2.71,7.13a1.33,1.33,0,0,0,.72,1.65L60.64,191a1.52,1.52,0,0,1,.18.95,27.8,27.8,0,0,0-.31,3.36,3.8,3.8,0,0,1-1,2.31l-.05,0L55,202.07a1.64,1.64,0,0,0-.21.25s0,0,0,.05a1.17,1.17,0,0,0-.17.31,2.42,2.42,0,0,0-.21,1.68l1.39,4.93a1.08,1.08,0,0,0,.5.66l6.12,2.84a1,1,0,0,1-.47-.64l-1.39-4.93a2.06,2.06,0,0,1,0-1,2.43,2.43,0,0,1,.65-1.33l4.48-4.37,0-.05a3.87,3.87,0,0,0,1-2.32,25.92,25.92,0,0,1,.31-3.35,1.73,1.73,0,0,0-1.16-1.8l-3-1a1.36,1.36,0,0,1-.92-1.73l2.71-7.13a1.91,1.91,0,0,1,.51-.7,2.28,2.28,0,0,1,1.44-.56h3.59a2.33,2.33,0,0,0,1-.23,2.54,2.54,0,0,0,1.14-.93c.71-1.13,1.48-2.23,2.29-3.28a3.53,3.53,0,0,0,.64-2.41l-.78-4.88a2,2,0,0,1,0-.86,2.66,2.66,0,0,1,.8-1.38l5.19-4.3a1,1,0,0,1,1.08-.2ZM71.92,213a2.26,2.26,0,0,0-.78-2.15,8.67,8.67,0,0,1-1.06-1,1.54,1.54,0,0,0-2-.33l-2.66,1.84-1.56,5.22a1.13,1.13,0,0,0,.62,1.37h0l6.16,2.87a1.15,1.15,0,0,1-.62-1.39Z"
          style={{
            fill: "#fff",
            opacity: 0.7000000000000001,
          }}
        />
        <path
          d="M101,164.6h0a1,1,0,0,0-1,.13l-2,1.38-.36,1.19a2.23,2.23,0,0,0,.78,2.15,9.54,9.54,0,0,1,1.06,1,1.54,1.54,0,0,0,2,.31l4.64-3.23a1,1,0,0,1,1-.14Zm-6,17.09c-1-3.66-3.74-5.39-7-5a9.1,9.1,0,0,1,.88,2.13c1.64,5.81-1.6,14.3-7.21,19a12.09,12.09,0,0,1-6.08,2.9c2.34,3.84,7.38,4,12.23,0C93.33,196,96.56,187.5,94.92,181.69Zm-2.22-25h0a1.25,1.25,0,0,0-.4-.13l-3.78-.6a2,2,0,0,0-2,1l-2.92,6.32a2.77,2.77,0,0,1-.7.86h0a3.52,3.52,0,0,1-.56.39l1.4,3.32a1.34,1.34,0,0,0,1.82.65,19.9,19.9,0,0,1,2.22-.8A3.55,3.55,0,0,0,89,167a2.57,2.57,0,0,0,.71-.86l2.91-6.33a2,2,0,0,1,2-1l3.79.6a1.41,1.41,0,0,1,.38.11Zm-4.9,60.11a1,1,0,0,1-.4-.5l-1.61-3.8A1.35,1.35,0,0,0,84,211.8a18,18,0,0,1-2.22.8,2.62,2.62,0,0,0-.69.31l.21.49a1.06,1.06,0,0,0,.53.57h0ZM75.42,160.57a1.16,1.16,0,0,0-.42-.08,1.09,1.09,0,0,0-.66.28l-5.19,4.3a1.21,1.21,0,0,0-.19.2.65.65,0,0,0-.13.16,3,3,0,0,0-.42.83,1.17,1.17,0,0,1,0,.2h0a2.05,2.05,0,0,0-.06.84l.78,4.89a3.57,3.57,0,0,1-.64,2.41,39.25,39.25,0,0,0-2.29,3.28,2.59,2.59,0,0,1-1.14.93,2.7,2.7,0,0,1-.48.16.85.85,0,0,1-.23,0,1.12,1.12,0,0,1-.32,0H60.32l-.29,0-.26.07h0a1.69,1.69,0,0,0-.28.12,2.76,2.76,0,0,0-.49.32,2,2,0,0,0-.51.7l-2.71,7.13a1.33,1.33,0,0,0,.72,1.65L60.64,191a1.52,1.52,0,0,1,.18.95,27.8,27.8,0,0,0-.31,3.36,3.8,3.8,0,0,1-1,2.31l-.05,0L55,202.07a1.64,1.64,0,0,0-.21.25s0,0,0,.05a1.17,1.17,0,0,0-.17.31,2.42,2.42,0,0,0-.21,1.68l1.39,4.93a1.08,1.08,0,0,0,.5.66l6.12,2.84a1,1,0,0,1-.47-.64l-1.39-4.93a2.06,2.06,0,0,1,0-1,2.43,2.43,0,0,1,.65-1.33l4.48-4.37,0-.05a3.87,3.87,0,0,0,1-2.32,25.92,25.92,0,0,1,.31-3.35,1.73,1.73,0,0,0-1.16-1.8l-3-1a1.36,1.36,0,0,1-.92-1.73l2.71-7.13a1.91,1.91,0,0,1,.51-.7,2.28,2.28,0,0,1,1.44-.56h3.59a2.33,2.33,0,0,0,1-.23,2.54,2.54,0,0,0,1.14-.93c.71-1.13,1.48-2.23,2.29-3.28a3.53,3.53,0,0,0,.64-2.41l-.78-4.88a2,2,0,0,1,0-.86,2.66,2.66,0,0,1,.8-1.38l5.19-4.3a1,1,0,0,1,1.08-.2ZM71.92,213a2.26,2.26,0,0,0-.78-2.15,8.67,8.67,0,0,1-1.06-1,1.54,1.54,0,0,0-2-.33l-2.66,1.84-1.56,5.22a1.13,1.13,0,0,0,.62,1.37h0l6.16,2.87a1.15,1.15,0,0,1-.62-1.39Z"
          style={{
            opacity: 0.05,
          }}
        />
        <path
          d="M65.61,200.56l-4.48,4.37a2.43,2.43,0,0,0-.65,1.33l-6.13-2.85a2.94,2.94,0,0,1,.22-.73,1.17,1.17,0,0,1,.17-.31s0,0,0-.05a1.64,1.64,0,0,1,.21-.25l4.5-4.37Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M71.16,181.67a2.33,2.33,0,0,1-1,.23H66.55a2.28,2.28,0,0,0-1.44.56L59,179.61a2.76,2.76,0,0,1,.49-.32,1.69,1.69,0,0,1,.28-.12h0l.26-.07.29,0H64a1.12,1.12,0,0,0,.32,0l.23,0,.46-.17h0Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M107.08,167.44a1,1,0,0,0-1,.16l-4.64,3.23a1.55,1.55,0,0,1-2-.33,8.67,8.67,0,0,0-1.06-1,2.23,2.23,0,0,1-.78-2.15l.36-1.18,2-1.39a1,1,0,0,1,1-.14h0Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M98.83,159.5a1.41,1.41,0,0,0-.38-.11l-3.79-.6a2,2,0,0,0-2,1l-2.91,6.33A2.57,2.57,0,0,1,89,167l-6.14-2.86a2.77,2.77,0,0,0,.7-.86l2.92-6.32a2,2,0,0,1,2-1l3.78.6a1.25,1.25,0,0,1,.4.13h0Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M81.57,163.43a1,1,0,0,0-1.08.2l-5.19,4.3a2.66,2.66,0,0,0-.8,1.38l-6.14-2.85a1.17,1.17,0,0,0,0-.2,3,3,0,0,1,.42-.83.65.65,0,0,1,.13-.16,1.21,1.21,0,0,1,.19-.2l5.19-4.3a1.09,1.09,0,0,1,.66-.28,1.16,1.16,0,0,1,.42.08Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M65.61,200.56l-4.48,4.37a2.43,2.43,0,0,0-.65,1.33l-6.13-2.85a2.94,2.94,0,0,1,.22-.73,1.17,1.17,0,0,1,.17-.31s0,0,0-.05a1.64,1.64,0,0,1,.21-.25l4.5-4.37Z"
          style={{
            fill: "#fff",
            opacity: 0.9,
          }}
        />
        <path
          d="M71.16,181.67a2.33,2.33,0,0,1-1,.23H66.55a2.28,2.28,0,0,0-1.44.56L59,179.61a2.76,2.76,0,0,1,.49-.32,1.69,1.69,0,0,1,.28-.12h0l.26-.07.29,0H64a1.12,1.12,0,0,0,.32,0l.23,0,.46-.17h0Z"
          style={{
            fill: "#fff",
            opacity: 0.9,
          }}
        />
        <path
          d="M107.08,167.44a1,1,0,0,0-1,.16l-4.64,3.23a1.55,1.55,0,0,1-2-.33,8.67,8.67,0,0,0-1.06-1,2.23,2.23,0,0,1-.78-2.15l.36-1.18,2-1.39a1,1,0,0,1,1-.14h0Z"
          style={{
            fill: "#fff",
            opacity: 0.9,
          }}
        />
        <path
          d="M98.83,159.5a1.41,1.41,0,0,0-.38-.11l-3.79-.6a2,2,0,0,0-2,1l-2.91,6.33A2.57,2.57,0,0,1,89,167l-6.14-2.86a2.77,2.77,0,0,0,.7-.86l2.92-6.32a2,2,0,0,1,2-1l3.78.6a1.25,1.25,0,0,1,.4.13h0Z"
          style={{
            fill: "#fff",
            opacity: 0.9,
          }}
        />
        <path
          d="M81.57,163.43a1,1,0,0,0-1.08.2l-5.19,4.3a2.66,2.66,0,0,0-.8,1.38l-6.14-2.85a1.17,1.17,0,0,0,0-.2,3,3,0,0,1,.42-.83.65.65,0,0,1,.13-.16,1.21,1.21,0,0,1,.19-.2l5.19-4.3a1.09,1.09,0,0,1,.66-.28,1.16,1.16,0,0,1,.42.08Z"
          style={{
            fill: "#fff",
            opacity: 0.9,
          }}
        />
        <path
          d="M109,173.05l-1.38-4.93a.93.93,0,0,0-1.53-.52l-4.64,3.22a1.53,1.53,0,0,1-2-.32,8.67,8.67,0,0,0-1.06-1,2.26,2.26,0,0,1-.78-2.15l1.93-6.4a1.2,1.2,0,0,0-1.07-1.52l-3.78-.6a2,2,0,0,0-2,1l-2.91,6.32a3.48,3.48,0,0,1-2,1.56,18.56,18.56,0,0,0-2.22.8,1.34,1.34,0,0,1-1.83-.66L82.1,164a1,1,0,0,0-1.61-.38l-5.19,4.3a2.66,2.66,0,0,0-.85,2.23l.79,4.89a3.54,3.54,0,0,1-.65,2.41,39.25,39.25,0,0,0-2.29,3.28,2.78,2.78,0,0,1-2.16,1.17H66.55a2.18,2.18,0,0,0-1.94,1.26L61.9,190.3a1.34,1.34,0,0,0,.91,1.73l3,1a1.72,1.72,0,0,1,1.17,1.8,25.76,25.76,0,0,0-.31,3.35,3.87,3.87,0,0,1-1,2.32l-4.53,4.42a2.53,2.53,0,0,0-.62,2.29l1.39,4.93a.92.92,0,0,0,1.52.52l4.64-3.22a1.53,1.53,0,0,1,2,.32,9.44,9.44,0,0,0,1.06,1,2.26,2.26,0,0,1,.78,2.15L70,219.36a1.2,1.2,0,0,0,1.07,1.52l3.78.6a2,2,0,0,0,2-1l2.91-6.32a3.47,3.47,0,0,1,2-1.56,19.21,19.21,0,0,0,2.22-.8,1.33,1.33,0,0,1,1.82.66l1.61,3.8a1,1,0,0,0,1.62.38l5.18-4.3a2.66,2.66,0,0,0,.85-2.23l-.79-4.89a3.54,3.54,0,0,1,.65-2.41,39.25,39.25,0,0,0,2.29-3.28,2.78,2.78,0,0,1,2.16-1.17H103a2.2,2.2,0,0,0,2-1.26l2.71-7.13a1.35,1.35,0,0,0-.92-1.73l-3-1a1.72,1.72,0,0,1-1.16-1.8,29.8,29.8,0,0,0,.31-3.35,3.8,3.8,0,0,1,1-2.32l4.54-4.42A2.56,2.56,0,0,0,109,173.05ZM87.71,200.66c-5.62,4.66-11.5,3.73-13.13-2.08s1.59-14.3,7.21-19,11.5-3.73,13.13,2.08S93.33,196,87.71,200.66Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M109,173.05l-1.38-4.93a.93.93,0,0,0-1.53-.52l-4.64,3.22a1.53,1.53,0,0,1-2-.32,8.67,8.67,0,0,0-1.06-1,2.26,2.26,0,0,1-.78-2.15l1.93-6.4a1.2,1.2,0,0,0-1.07-1.52l-3.78-.6a2,2,0,0,0-2,1l-2.91,6.32a3.48,3.48,0,0,1-2,1.56,18.56,18.56,0,0,0-2.22.8,1.34,1.34,0,0,1-1.83-.66L82.1,164a1,1,0,0,0-1.61-.38l-5.19,4.3a2.66,2.66,0,0,0-.85,2.23l.79,4.89a3.54,3.54,0,0,1-.65,2.41,39.25,39.25,0,0,0-2.29,3.28,2.78,2.78,0,0,1-2.16,1.17H66.55a2.18,2.18,0,0,0-1.94,1.26L61.9,190.3a1.34,1.34,0,0,0,.91,1.73l3,1a1.72,1.72,0,0,1,1.17,1.8,25.76,25.76,0,0,0-.31,3.35,3.87,3.87,0,0,1-1,2.32l-4.53,4.42a2.53,2.53,0,0,0-.62,2.29l1.39,4.93a.92.92,0,0,0,1.52.52l4.64-3.22a1.53,1.53,0,0,1,2,.32,9.44,9.44,0,0,0,1.06,1,2.26,2.26,0,0,1,.78,2.15L70,219.36a1.2,1.2,0,0,0,1.07,1.52l3.78.6a2,2,0,0,0,2-1l2.91-6.32a3.47,3.47,0,0,1,2-1.56,19.21,19.21,0,0,0,2.22-.8,1.33,1.33,0,0,1,1.82.66l1.61,3.8a1,1,0,0,0,1.62.38l5.18-4.3a2.66,2.66,0,0,0,.85-2.23l-.79-4.89a3.54,3.54,0,0,1,.65-2.41,39.25,39.25,0,0,0,2.29-3.28,2.78,2.78,0,0,1,2.16-1.17H103a2.2,2.2,0,0,0,2-1.26l2.71-7.13a1.35,1.35,0,0,0-.92-1.73l-3-1a1.72,1.72,0,0,1-1.16-1.8,29.8,29.8,0,0,0,.31-3.35,3.8,3.8,0,0,1,1-2.32l4.54-4.42A2.56,2.56,0,0,0,109,173.05ZM87.71,200.66c-5.62,4.66-11.5,3.73-13.13-2.08s1.59-14.3,7.21-19,11.5-3.73,13.13,2.08S93.33,196,87.71,200.66Z"
          style={{
            fill: "#fff",
            opacity: 0.75,
          }}
        />
        <path
          d="M113.59,76.25h0a1.4,1.4,0,0,0-1.43.15l-2.84,1.87-.54,1.66a3.11,3.11,0,0,0,1,3,14.83,14.83,0,0,1,1.46,1.5,2.15,2.15,0,0,0,2.81.51l6.61-4.36a1.45,1.45,0,0,1,1.4-.17Zm-9,23.73c-1.33-5.17-5.07-7.69-9.67-7.23a12.43,12.43,0,0,1,1.16,3c2.09,8.19-2.73,20-10.76,26.31a16.94,16.94,0,0,1-8.61,3.86c3.15,5.46,10.2,5.83,17.12.36C101.84,120,106.66,108.17,104.57,100Zm-2.25-35.15h0a2.3,2.3,0,0,0-.56-.19l-5.27-1A2.78,2.78,0,0,0,93.63,65l-4.31,8.76a3.8,3.8,0,0,1-1,1.17h0a4.32,4.32,0,0,1-.8.54l1.85,4.69a1.89,1.89,0,0,0,2.53,1,24.53,24.53,0,0,1,3.14-1,5.32,5.32,0,0,0,1.79-.94,3.46,3.46,0,0,0,1-1.19l4.3-8.75A2.79,2.79,0,0,1,105,67.89l5.29,1a1.83,1.83,0,0,1,.53.17Zm-8.95,84a1.5,1.5,0,0,1-.54-.72l-2.13-5.38a1.88,1.88,0,0,0-2.53-1A24.62,24.62,0,0,1,85,142.81a4.27,4.27,0,0,0-1,.41l.28.69a1.44,1.44,0,0,0,.72.82h0ZM78,69.73a1.27,1.27,0,0,0-.58-.13,1.56,1.56,0,0,0-.93.36l-7.42,5.85a1.77,1.77,0,0,0-.28.27,1,1,0,0,0-.19.22A4.35,4.35,0,0,0,68,77.45c0,.09,0,.19-.07.28h0a2.85,2.85,0,0,0-.12,1.17l.93,6.87a5,5,0,0,1-1,3.35c-1.18,1.45-2.28,3-3.31,4.52a3.64,3.64,0,0,1-1.64,1.26,2.74,2.74,0,0,1-.67.21,1.65,1.65,0,0,1-.32.06,2.27,2.27,0,0,1-.45,0l-5-.12h-.13a1.83,1.83,0,0,0-.4,0,1.53,1.53,0,0,0-.37.08s0,0,0,0a2.56,2.56,0,0,0-.4.16,3.07,3.07,0,0,0-.69.43,2.7,2.7,0,0,0-.74,1l-4,9.89a1.85,1.85,0,0,0,1,2.34l5.77,2.86a2.24,2.24,0,0,1,.22,1.34,40.3,40.3,0,0,0-.56,4.68,5.35,5.35,0,0,1-1.46,3.21l-.08.07-6.44,6a1.43,1.43,0,0,0-.3.35l0,.06a1.4,1.4,0,0,0-.24.43,3.38,3.38,0,0,0-.36,2.35l1.78,7a1.41,1.41,0,0,0,.67.94l8.47,4.19a1.44,1.44,0,0,1-.64-.91l-1.77-7a3,3,0,0,1,0-1.34,3.44,3.44,0,0,1,1-1.84l6.42-6,.08-.06a5.52,5.52,0,0,0,1.48-3.21,36.49,36.49,0,0,1,.55-4.69,2.41,2.41,0,0,0-1.57-2.56l-4.16-1.51A1.9,1.9,0,0,1,58,110.89l4-9.89a2.42,2.42,0,0,1,.74-1,3.14,3.14,0,0,1,2-.74l5,.12a3.45,3.45,0,0,0,1.42-.3,3.71,3.71,0,0,0,1.64-1.26c1-1.56,2.14-3.08,3.31-4.52a4.87,4.87,0,0,0,1-3.35l-.93-6.86a2.89,2.89,0,0,1,.11-1.19A3.6,3.6,0,0,1,77.57,80L85,74.18a1.41,1.41,0,0,1,1.53-.24ZM71.27,143a3.15,3.15,0,0,0-1-3,14.62,14.62,0,0,1-1.44-1.5,2.15,2.15,0,0,0-2.81-.53l-3.78,2.49-2.38,7.24a1.6,1.6,0,0,0,.83,2h0l8.53,4.23a1.6,1.6,0,0,1-.83-2Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M113.59,76.25h0a1.4,1.4,0,0,0-1.43.15l-2.84,1.87-.54,1.66a3.11,3.11,0,0,0,1,3,14.83,14.83,0,0,1,1.46,1.5,2.15,2.15,0,0,0,2.81.51l6.61-4.36a1.45,1.45,0,0,1,1.4-.17Zm-9,23.73c-1.33-5.17-5.07-7.69-9.67-7.23a12.43,12.43,0,0,1,1.16,3c2.09,8.19-2.73,20-10.76,26.31a16.94,16.94,0,0,1-8.61,3.86c3.15,5.46,10.2,5.83,17.12.36C101.84,120,106.66,108.17,104.57,100Zm-2.25-35.15h0a2.3,2.3,0,0,0-.56-.19l-5.27-1A2.78,2.78,0,0,0,93.63,65l-4.31,8.76a3.8,3.8,0,0,1-1,1.17h0a4.32,4.32,0,0,1-.8.54l1.85,4.69a1.89,1.89,0,0,0,2.53,1,24.53,24.53,0,0,1,3.14-1,5.32,5.32,0,0,0,1.79-.94,3.46,3.46,0,0,0,1-1.19l4.3-8.75A2.79,2.79,0,0,1,105,67.89l5.29,1a1.83,1.83,0,0,1,.53.17Zm-8.95,84a1.5,1.5,0,0,1-.54-.72l-2.13-5.38a1.88,1.88,0,0,0-2.53-1A24.62,24.62,0,0,1,85,142.81a4.27,4.27,0,0,0-1,.41l.28.69a1.44,1.44,0,0,0,.72.82h0ZM78,69.73a1.27,1.27,0,0,0-.58-.13,1.56,1.56,0,0,0-.93.36l-7.42,5.85a1.77,1.77,0,0,0-.28.27,1,1,0,0,0-.19.22A4.35,4.35,0,0,0,68,77.45c0,.09,0,.19-.07.28h0a2.85,2.85,0,0,0-.12,1.17l.93,6.87a5,5,0,0,1-1,3.35c-1.18,1.45-2.28,3-3.31,4.52a3.64,3.64,0,0,1-1.64,1.26,2.74,2.74,0,0,1-.67.21,1.65,1.65,0,0,1-.32.06,2.27,2.27,0,0,1-.45,0l-5-.12h-.13a1.83,1.83,0,0,0-.4,0,1.53,1.53,0,0,0-.37.08s0,0,0,0a2.56,2.56,0,0,0-.4.16,3.07,3.07,0,0,0-.69.43,2.7,2.7,0,0,0-.74,1l-4,9.89a1.85,1.85,0,0,0,1,2.34l5.77,2.86a2.24,2.24,0,0,1,.22,1.34,40.3,40.3,0,0,0-.56,4.68,5.35,5.35,0,0,1-1.46,3.21l-.08.07-6.44,6a1.43,1.43,0,0,0-.3.35l0,.06a1.4,1.4,0,0,0-.24.43,3.38,3.38,0,0,0-.36,2.35l1.78,7a1.41,1.41,0,0,0,.67.94l8.47,4.19a1.44,1.44,0,0,1-.64-.91l-1.77-7a3,3,0,0,1,0-1.34,3.44,3.44,0,0,1,1-1.84l6.42-6,.08-.06a5.52,5.52,0,0,0,1.48-3.21,36.49,36.49,0,0,1,.55-4.69,2.41,2.41,0,0,0-1.57-2.56l-4.16-1.51A1.9,1.9,0,0,1,58,110.89l4-9.89a2.42,2.42,0,0,1,.74-1,3.14,3.14,0,0,1,2-.74l5,.12a3.45,3.45,0,0,0,1.42-.3,3.71,3.71,0,0,0,1.64-1.26c1-1.56,2.14-3.08,3.31-4.52a4.87,4.87,0,0,0,1-3.35l-.93-6.86a2.89,2.89,0,0,1,.11-1.19A3.6,3.6,0,0,1,77.57,80L85,74.18a1.41,1.41,0,0,1,1.53-.24ZM71.27,143a3.15,3.15,0,0,0-1-3,14.62,14.62,0,0,1-1.44-1.5,2.15,2.15,0,0,0-2.81-.53l-3.78,2.49-2.38,7.24a1.6,1.6,0,0,0,.83,2h0l8.53,4.23a1.6,1.6,0,0,1-.83-2Z"
          style={{
            fill: "#fff",
            opacity: 0.7000000000000001,
          }}
        />
        <path
          d="M113.59,76.25h0a1.4,1.4,0,0,0-1.43.15l-2.84,1.87-.54,1.66a3.11,3.11,0,0,0,1,3,14.83,14.83,0,0,1,1.46,1.5,2.15,2.15,0,0,0,2.81.51l6.61-4.36a1.45,1.45,0,0,1,1.4-.17Zm-9,23.73c-1.33-5.17-5.07-7.69-9.67-7.23a12.43,12.43,0,0,1,1.16,3c2.09,8.19-2.73,20-10.76,26.31a16.94,16.94,0,0,1-8.61,3.86c3.15,5.46,10.2,5.83,17.12.36C101.84,120,106.66,108.17,104.57,100Zm-2.25-35.15h0a2.3,2.3,0,0,0-.56-.19l-5.27-1A2.78,2.78,0,0,0,93.63,65l-4.31,8.76a3.8,3.8,0,0,1-1,1.17h0a4.32,4.32,0,0,1-.8.54l1.85,4.69a1.89,1.89,0,0,0,2.53,1,24.53,24.53,0,0,1,3.14-1,5.32,5.32,0,0,0,1.79-.94,3.46,3.46,0,0,0,1-1.19l4.3-8.75A2.79,2.79,0,0,1,105,67.89l5.29,1a1.83,1.83,0,0,1,.53.17Zm-8.95,84a1.5,1.5,0,0,1-.54-.72l-2.13-5.38a1.88,1.88,0,0,0-2.53-1A24.62,24.62,0,0,1,85,142.81a4.27,4.27,0,0,0-1,.41l.28.69a1.44,1.44,0,0,0,.72.82h0ZM78,69.73a1.27,1.27,0,0,0-.58-.13,1.56,1.56,0,0,0-.93.36l-7.42,5.85a1.77,1.77,0,0,0-.28.27,1,1,0,0,0-.19.22A4.35,4.35,0,0,0,68,77.45c0,.09,0,.19-.07.28h0a2.85,2.85,0,0,0-.12,1.17l.93,6.87a5,5,0,0,1-1,3.35c-1.18,1.45-2.28,3-3.31,4.52a3.64,3.64,0,0,1-1.64,1.26,2.74,2.74,0,0,1-.67.21,1.65,1.65,0,0,1-.32.06,2.27,2.27,0,0,1-.45,0l-5-.12h-.13a1.83,1.83,0,0,0-.4,0,1.53,1.53,0,0,0-.37.08s0,0,0,0a2.56,2.56,0,0,0-.4.16,3.07,3.07,0,0,0-.69.43,2.7,2.7,0,0,0-.74,1l-4,9.89a1.85,1.85,0,0,0,1,2.34l5.77,2.86a2.24,2.24,0,0,1,.22,1.34,40.3,40.3,0,0,0-.56,4.68,5.35,5.35,0,0,1-1.46,3.21l-.08.07-6.44,6a1.43,1.43,0,0,0-.3.35l0,.06a1.4,1.4,0,0,0-.24.43,3.38,3.38,0,0,0-.36,2.35l1.78,7a1.41,1.41,0,0,0,.67.94l8.47,4.19a1.44,1.44,0,0,1-.64-.91l-1.77-7a3,3,0,0,1,0-1.34,3.44,3.44,0,0,1,1-1.84l6.42-6,.08-.06a5.52,5.52,0,0,0,1.48-3.21,36.49,36.49,0,0,1,.55-4.69,2.41,2.41,0,0,0-1.57-2.56l-4.16-1.51A1.9,1.9,0,0,1,58,110.89l4-9.89a2.42,2.42,0,0,1,.74-1,3.14,3.14,0,0,1,2-.74l5,.12a3.45,3.45,0,0,0,1.42-.3,3.71,3.71,0,0,0,1.64-1.26c1-1.56,2.14-3.08,3.31-4.52a4.87,4.87,0,0,0,1-3.35l-.93-6.86a2.89,2.89,0,0,1,.11-1.19A3.6,3.6,0,0,1,77.57,80L85,74.18a1.41,1.41,0,0,1,1.53-.24ZM71.27,143a3.15,3.15,0,0,0-1-3,14.62,14.62,0,0,1-1.44-1.5,2.15,2.15,0,0,0-2.81-.53l-3.78,2.49-2.38,7.24a1.6,1.6,0,0,0,.83,2h0l8.53,4.23a1.6,1.6,0,0,1-.83-2Z"
          style={{
            opacity: 0.05,
          }}
        />
        <path
          d="M62.85,125.38l-6.42,6a3.44,3.44,0,0,0-1,1.84L47,129a4.39,4.39,0,0,1,.35-1,1.4,1.4,0,0,1,.24-.43l0-.06a1.43,1.43,0,0,1,.3-.35l6.44-6Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M71.28,99.12a3.45,3.45,0,0,1-1.42.3l-5-.12a3.14,3.14,0,0,0-2,.74l-8.5-4.22a3.07,3.07,0,0,1,.69-.43,2.56,2.56,0,0,1,.4-.16s0,0,0,0a1.53,1.53,0,0,1,.37-.08,1.83,1.83,0,0,1,.4,0h.13l5,.12a2.27,2.27,0,0,0,.45,0,3,3,0,0,0,.32-.06c.22-.06.43-.14.64-.22h0Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M122.08,80.45a1.38,1.38,0,0,0-1.4.18L114.07,85a2.15,2.15,0,0,1-2.81-.53A14.8,14.8,0,0,0,109.8,83a3.1,3.1,0,0,1-1-3l.54-1.65,2.84-1.87a1.41,1.41,0,0,1,1.42-.16h0Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M110.81,69a1.83,1.83,0,0,0-.53-.17l-5.29-1a2.79,2.79,0,0,0-2.86,1.33L97.83,78a3.46,3.46,0,0,1-1,1.19l-8.5-4.23a3.8,3.8,0,0,0,1-1.17L93.63,65a2.78,2.78,0,0,1,2.86-1.33l5.27,1a2.3,2.3,0,0,1,.56.19h0Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M86.5,73.94a1.41,1.41,0,0,0-1.53.24L77.57,80a3.6,3.6,0,0,0-1.17,1.92l-8.5-4.21c0-.09,0-.19.07-.28a4.35,4.35,0,0,1,.61-1.15,1,1,0,0,1,.19-.22,1.77,1.77,0,0,1,.28-.27L76.47,70a1.56,1.56,0,0,1,.93-.36,1.27,1.27,0,0,1,.58.13Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M62.85,125.38l-6.42,6a3.44,3.44,0,0,0-1,1.84L47,129a4.39,4.39,0,0,1,.35-1,1.4,1.4,0,0,1,.24-.43l0-.06a1.43,1.43,0,0,1,.3-.35l6.44-6Z"
          style={{
            fill: "#fff",
            opacity: 0.9,
          }}
        />
        <path
          d="M71.28,99.12a3.45,3.45,0,0,1-1.42.3l-5-.12a3.14,3.14,0,0,0-2,.74l-8.5-4.22a3.07,3.07,0,0,1,.69-.43,2.56,2.56,0,0,1,.4-.16s0,0,0,0a1.53,1.53,0,0,1,.37-.08,1.83,1.83,0,0,1,.4,0h.13l5,.12a2.27,2.27,0,0,0,.45,0,3,3,0,0,0,.32-.06c.22-.06.43-.14.64-.22h0Z"
          style={{
            fill: "#fff",
            opacity: 0.9,
          }}
        />
        <path
          d="M122.08,80.45a1.38,1.38,0,0,0-1.4.18L114.07,85a2.15,2.15,0,0,1-2.81-.53A14.8,14.8,0,0,0,109.8,83a3.1,3.1,0,0,1-1-3l.54-1.65,2.84-1.87a1.41,1.41,0,0,1,1.42-.16h0Z"
          style={{
            fill: "#fff",
            opacity: 0.9,
          }}
        />
        <path
          d="M110.81,69a1.83,1.83,0,0,0-.53-.17l-5.29-1a2.79,2.79,0,0,0-2.86,1.33L97.83,78a3.46,3.46,0,0,1-1,1.19l-8.5-4.23a3.8,3.8,0,0,0,1-1.17L93.63,65a2.78,2.78,0,0,1,2.86-1.33l5.27,1a2.3,2.3,0,0,1,.56.19h0Z"
          style={{
            fill: "#fff",
            opacity: 0.9,
          }}
        />
        <path
          d="M86.5,73.94a1.41,1.41,0,0,0-1.53.24L77.57,80a3.6,3.6,0,0,0-1.17,1.92l-8.5-4.21c0-.09,0-.19.07-.28a4.35,4.35,0,0,1,.61-1.15,1,1,0,0,1,.19-.22,1.77,1.77,0,0,1,.28-.27L76.47,70a1.56,1.56,0,0,1,.93-.36,1.27,1.27,0,0,1,.58.13Z"
          style={{
            fill: "#fff",
            opacity: 0.9,
          }}
        />
        <path
          d="M124.57,88.37l-1.77-7a1.3,1.3,0,0,0-2.12-.78L114.07,85a2.13,2.13,0,0,1-2.81-.52,15.86,15.86,0,0,0-1.45-1.5,3.1,3.1,0,0,1-1-3l2.92-8.9a1.68,1.68,0,0,0-1.44-2.16l-5.28-1a2.77,2.77,0,0,0-2.86,1.32L97.83,78A4.78,4.78,0,0,1,95,80.09a25.58,25.58,0,0,0-3.13,1,1.89,1.89,0,0,1-2.54-1l-2.12-5.37a1.37,1.37,0,0,0-2.25-.6L77.56,80a3.77,3.77,0,0,0-1.27,3.1L77.22,90a4.94,4.94,0,0,1-1,3.35q-1.77,2.18-3.32,4.52a3.93,3.93,0,0,1-3.07,1.56l-5-.12a3.06,3.06,0,0,0-2.76,1.7L58,110.89a1.88,1.88,0,0,0,1.22,2.45l4.16,1.52A2.4,2.4,0,0,1,65,117.42a42.72,42.72,0,0,0-.55,4.69,5.33,5.33,0,0,1-1.47,3.21l-6.51,6a3.59,3.59,0,0,0-.94,3.18l1.77,7a1.3,1.3,0,0,0,2.12.78L66,137.92a2.15,2.15,0,0,1,2.82.52,14.62,14.62,0,0,0,1.44,1.5,3.09,3.09,0,0,1,1,3l-2.92,8.9A1.68,1.68,0,0,0,69.78,154l5.28,1a2.77,2.77,0,0,0,2.86-1.32l4.3-8.75A4.78,4.78,0,0,1,85,142.81a25.71,25.71,0,0,0,3.14-1.05,1.88,1.88,0,0,1,2.53,1l2.13,5.37a1.36,1.36,0,0,0,2.24.6l7.41-5.84a3.77,3.77,0,0,0,1.27-3.1l-.93-6.87a4.94,4.94,0,0,1,1-3.35q1.77-2.17,3.32-4.52a3.93,3.93,0,0,1,3.07-1.56l5,.12a3.08,3.08,0,0,0,2.77-1.7l4-9.89a1.88,1.88,0,0,0-1.22-2.45L116.66,108a2.41,2.41,0,0,1-1.56-2.56,40.42,40.42,0,0,0,.55-4.69,5.39,5.39,0,0,1,1.47-3.21l6.51-6A3.59,3.59,0,0,0,124.57,88.37ZM93.81,126.29c-8,6.34-16.24,4.83-18.33-3.37s2.73-20,10.76-26.31,16.24-4.83,18.33,3.37S101.84,120,93.81,126.29Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M124.57,88.37l-1.77-7a1.3,1.3,0,0,0-2.12-.78L114.07,85a2.13,2.13,0,0,1-2.81-.52,15.86,15.86,0,0,0-1.45-1.5,3.1,3.1,0,0,1-1-3l2.92-8.9a1.68,1.68,0,0,0-1.44-2.16l-5.28-1a2.77,2.77,0,0,0-2.86,1.32L97.83,78A4.78,4.78,0,0,1,95,80.09a25.58,25.58,0,0,0-3.13,1,1.89,1.89,0,0,1-2.54-1l-2.12-5.37a1.37,1.37,0,0,0-2.25-.6L77.56,80a3.77,3.77,0,0,0-1.27,3.1L77.22,90a4.94,4.94,0,0,1-1,3.35q-1.77,2.18-3.32,4.52a3.93,3.93,0,0,1-3.07,1.56l-5-.12a3.06,3.06,0,0,0-2.76,1.7L58,110.89a1.88,1.88,0,0,0,1.22,2.45l4.16,1.52A2.4,2.4,0,0,1,65,117.42a42.72,42.72,0,0,0-.55,4.69,5.33,5.33,0,0,1-1.47,3.21l-6.51,6a3.59,3.59,0,0,0-.94,3.18l1.77,7a1.3,1.3,0,0,0,2.12.78L66,137.92a2.15,2.15,0,0,1,2.82.52,14.62,14.62,0,0,0,1.44,1.5,3.09,3.09,0,0,1,1,3l-2.92,8.9A1.68,1.68,0,0,0,69.78,154l5.28,1a2.77,2.77,0,0,0,2.86-1.32l4.3-8.75A4.78,4.78,0,0,1,85,142.81a25.71,25.71,0,0,0,3.14-1.05,1.88,1.88,0,0,1,2.53,1l2.13,5.37a1.36,1.36,0,0,0,2.24.6l7.41-5.84a3.77,3.77,0,0,0,1.27-3.1l-.93-6.87a4.94,4.94,0,0,1,1-3.35q1.77-2.17,3.32-4.52a3.93,3.93,0,0,1,3.07-1.56l5,.12a3.08,3.08,0,0,0,2.77-1.7l4-9.89a1.88,1.88,0,0,0-1.22-2.45L116.66,108a2.41,2.41,0,0,1-1.56-2.56,40.42,40.42,0,0,0,.55-4.69,5.39,5.39,0,0,1,1.47-3.21l6.51-6A3.59,3.59,0,0,0,124.57,88.37ZM93.81,126.29c-8,6.34-16.24,4.83-18.33-3.37s2.73-20,10.76-26.31,16.24-4.83,18.33,3.37S101.84,120,93.81,126.29Z"
          style={{
            fill: "#fff",
            opacity: 0.75,
          }}
        />
      </g>
    </g>
    <g id="freepik--Device--inject-435">
      <g id="freepik--device--inject-435">
        <path
          d="M234.19,29.73,97.61,108.59a12,12,0,0,0-6.3,11.6l43.45,303.16c.67,4.62,4.76,9.88,9.15,11.74s11.47,1.35,15.8-1.15L295.8,355.37c4.31-2.49,7.3-8.29,6.64-12.89L259.14,40.31c-.66-4.62-4.76-9.87-9.15-11.74S238.52,27.23,234.19,29.73Z"
          fill={theme.text}
        />
        <path
          d="M157.8,434.85c-4.29,1.69-10.09,1.85-13.89.24-4.39-1.86-8.49-7.12-9.15-11.74L91.31,120.19a10.83,10.83,0,0,1,1.24-6.29L107.13,120a11.86,11.86,0,0,0-2.72,8.61l43,300.16C148.22,434.31,152.69,436.77,157.8,434.85Z"
          fill={theme.text}
        />
        <path
          d="M110.27,117.21c-3.81,2.19-6.44,7.31-5.86,11.37l43,300.17c.9,6.24,6.42,8.58,12.27,5.2L295.8,355.37c4.31-2.49,7.3-8.29,6.64-12.89L259.14,40.31c-.66-4.6-4.73-6.32-9-3.83Z"
          fill={theme.text}
        />
        <path
          d="M120.46,134.78c-4.11,2.37-6.94,7.86-6.31,12.25l37.22,259.66c.63,4.39,4.47,6,8.59,3.65l128-73.93c4.1-2.36,6.94-7.88,6.32-12.25L257.09,64.5c-.63-4.38-4.5-6-8.6-3.65Z"
          fill={theme.text}
        />
        <path d="M172.07,91.79l22.69-13.1c1.35-.78,2.61-.32,2.8,1a4.26,4.26,0,0,1-2.1,3.86L172.77,96.7c-1.36.78-2.61.31-2.8-1A4.23,4.23,0,0,1,172.07,91.79Z" />
        <path d="M211,69.28c1.27-.73,2.46-.23,2.65,1.12a4.1,4.1,0,0,1-2,3.78c-1.27.74-2.46.23-2.65-1.12A4.1,4.1,0,0,1,211,69.28Z" />
        <path d="M220.2,64c1.27-.73,2.46-.23,2.66,1.13a4.12,4.12,0,0,1-2,3.78c-1.27.73-2.46.23-2.65-1.13A4.08,4.08,0,0,1,220.2,64Z" />
        <path d="M146.61,106.46c1.27-.74,2.46-.23,2.65,1.12a4.08,4.08,0,0,1-1.95,3.78c-1.27.74-2.45.23-2.65-1.12A4.1,4.1,0,0,1,146.61,106.46Z" />
        <path d="M155.82,101.15c1.27-.73,2.45-.23,2.65,1.13a4.12,4.12,0,0,1-1.95,3.78c-1.27.73-2.46.23-2.65-1.13A4.09,4.09,0,0,1,155.82,101.15Z" />
        <path
          d="M283.33,318.84,246.51,62l-126,72.79c-4.11,2.37-6.94,7.86-6.31,12.25L151,403.87l126-72.78C281.11,328.72,284,323.21,283.33,318.84Z"
          fill={theme.imageHighlight}
        />
        <g
          style={{
            opacity: 0.6000000000000001,
          }}
        >
          <path
            d="M154.41,151.47a.45.45,0,0,0,.23-.46l-4.73-33.22-1.11.65,4.6,32.32-8.78,5.07a.44.44,0,0,0-.23.46l2.07,14.49a.6.6,0,0,0,.36.43l10.13,4.3L160.17,198a2.87,2.87,0,0,0-.84,2.24,1.15,1.15,0,0,0,1.88.8,2.9,2.9,0,0,0,1.38-2.68,1.07,1.07,0,0,0-1.3-1l-3.19-22.24a.56.56,0,0,0-.36-.43l-10.12-4.3-2-13.9Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M130.65,128.91,137.37,176a.59.59,0,0,0,.37.43l10.15,4.28,1.84,12.86a2.84,2.84,0,0,0-.84,2.25c.14,1,1,1.31,1.88.79a2.92,2.92,0,0,0,1.38-2.68,1.07,1.07,0,0,0-1.31-1L149,180.39a.56.56,0,0,0-.36-.43l-10.15-4.28-6.77-47.41Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M169.69,393.06l-7.57-52.83a.61.61,0,0,0-.36-.44l-10.13-4.3L131.81,197a2.82,2.82,0,0,0,.83-2.24c-.13-1-1-1.32-1.87-.8a2.9,2.9,0,0,0-1.38,2.68,1.07,1.07,0,0,0,1.3,1l19.79,138.18a.57.57,0,0,0,.36.44L161,340.57l7.61,53.14Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M121.62,134.13l6.72,47.11a.61.61,0,0,0,.36.44L138.83,186,142,208.43a2.87,2.87,0,0,0-.86,2.27c.13,1,1,1.32,1.88.8a2.92,2.92,0,0,0,1.38-2.68,1.08,1.08,0,0,0-1.28-1L140,185.62a.61.61,0,0,0-.37-.43L129.5,180.9l-6.77-47.42Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M246.69,348.6l-2.72-19a.6.6,0,0,0-.36-.43l-10.13-4.3L231,307.15a2.86,2.86,0,0,0,.84-2.24,1.15,1.15,0,0,0-1.88-.8,2.9,2.9,0,0,0-1.38,2.68,1.08,1.08,0,0,0,1.3,1l2.5,17.4a.56.56,0,0,0,.36.43l10.12,4.3,2.77,19.32Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M160.63,398.29l-3.92-27.35a2.89,2.89,0,0,0,.84-2.25c-.14-1-1-1.31-1.88-.79a2.9,2.9,0,0,0-1.38,2.68,1.06,1.06,0,0,0,1.3,1l3.92,27.36Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M267.7,257.7l-10.44-4.43a.66.66,0,0,0-.6,0L253,255.42l-4.7-32.79,7.62-14.77a.46.46,0,0,0,0-.26l-3.46-24.15a.59.59,0,0,0-.36-.44l-10.45-4.43a.7.7,0,0,0-.6,0l-3.69,2.13-4-28a.6.6,0,0,0-.37-.44L222.87,148l-2-13.95,13-7.53,9.8,4.16,5.56,38.8a2.86,2.86,0,0,0-.84,2.25c.14,1,1,1.31,1.88.79a2.89,2.89,0,0,0,1.38-2.67,1.08,1.08,0,0,0-1.31-1l-5.51-38.51a.56.56,0,0,0-.36-.43l-10.45-4.43a.67.67,0,0,0-.6,0l-12.75,7.37-7.37-51.65-1.12.64,7.38,51.65-4,2.29-10-4.15-6.06-42.5-1.11.64,6,42.21a.56.56,0,0,0,.36.43l10.61,4.43a.68.68,0,0,0,.59,0l3.7-2.13,2,13.65a.6.6,0,0,0,.37.44L232.2,153l4.06,28.34-30.6,17.67-6.79-47.42a.59.59,0,0,0-.36-.44l-15.35-6.51-6.07-42.58-1.11.64L182,145a.56.56,0,0,0,.36.43L197.71,152l6.84,47.72-22.1,12.75-9.8-4.15L159,112.56l-1.11.65,13.64,95.42a.57.57,0,0,0,.36.44l10.44,4.43a.7.7,0,0,0,.6,0l21.82-12.59,2.44,17.1a2.88,2.88,0,0,0-.83,2.25c.13,1,1,1.31,1.87.8a2.9,2.9,0,0,0,1.38-2.68,1.07,1.07,0,0,0-1.3-1l-2.45-17.1,30.6-17.67,4,27.71a2.89,2.89,0,0,0-.84,2.25,1.15,1.15,0,0,0,1.88.8,2.9,2.9,0,0,0,1.38-2.68,1.07,1.07,0,0,0-1.3-1l-4-27.71,4-2.3,9.8,4.16,3.4,23.73-7.61,14.77a.47.47,0,0,0,0,.26l4.8,33.52-12.47,7.2-8.68-60.59a2.82,2.82,0,0,0,.84-2.24c-.13-1-1-1.32-1.88-.8a2.94,2.94,0,0,0-1.38,2.68,1.09,1.09,0,0,0,1.31,1l8.67,60.58-12.47,7.21-5.91-41.27a2.82,2.82,0,0,0,.84-2.24,1.15,1.15,0,0,0-1.88-.8,2.9,2.9,0,0,0-1.38,2.68,1.08,1.08,0,0,0,1.31,1l5.9,41.26-21.53,12.43-1.21-8.47,8.78-5.07a.44.44,0,0,0,.23-.46l-3.26-22.83a2.82,2.82,0,0,0,.83-2.24c-.13-1-1-1.32-1.87-.8a2.9,2.9,0,0,0-1.38,2.68,1.07,1.07,0,0,0,1.3,1l3.14,21.93L200.92,275a.48.48,0,0,0-.24.46l1.35,9.37-7.95,4.58L184.71,224a2.86,2.86,0,0,0,.84-2.25c-.13-1-1-1.32-1.88-.8a2.94,2.94,0,0,0-1.38,2.68,1.08,1.08,0,0,0,1.31,1L193,290.07l-4,2.29-9.8-4.16-4.11-28.69a.56.56,0,0,0-.36-.43l-10.12-4.3-.94-6.55a2.82,2.82,0,0,0,.84-2.24,1.15,1.15,0,0,0-1.88-.8,2.9,2.9,0,0,0-1.38,2.68,1.07,1.07,0,0,0,1.31,1l.89,6.26a.6.6,0,0,0,.36.43l10.13,4.3,4.1,28.69a.59.59,0,0,0,.37.43l10.44,4.43a.66.66,0,0,0,.6,0l3.69-2.13,3.34,23.26a.56.56,0,0,0,.36.43l10.12,4.3,6.92,48.3,1.11-.64-6.87-48a.6.6,0,0,0-.36-.43l-10.13-4.3-3.37-23.56L202.2,286l1.94,13.6a.59.59,0,0,0,.37.43l10.12,4.3,8.3,58,1.11-.64L215.79,304a.59.59,0,0,0-.37-.43l-10.12-4.3-2-13.9L224.84,273l3.33,23.26a.6.6,0,0,0,.37.44l20.56,8.72L254.64,344l1.11-.65L250.26,305a.57.57,0,0,0-.36-.44l-20.57-8.72L226,272.31l12.47-7.21,3.33,23.27a.59.59,0,0,0,.37.43l15.34,6.51,6.23,43.48,1.11-.65L258.63,295a.61.61,0,0,0-.36-.44L242.92,288l-3.37-23.56,12.47-7.2,3.14,21.93a2.85,2.85,0,0,0-.83,2.25c.13,1,1,1.31,1.87.79a2.88,2.88,0,0,0,1.38-2.67,1.07,1.07,0,0,0-1.3-1l-3.14-21.94,4-2.29,9.8,4.16,10.38,72.46,1.11-.64-10.33-72.17A.59.59,0,0,0,267.7,257.7Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M178.74,387.83,171.18,335a.6.6,0,0,0-.36-.43l-10.13-4.3-6.75-47.15a2.86,2.86,0,0,0,.84-2.25,1.15,1.15,0,0,0-1.88-.8,2.92,2.92,0,0,0-1.38,2.68,1.08,1.08,0,0,0,1.31,1l6.71,46.86a.54.54,0,0,0,.36.43l10.12,4.3,7.61,53.14Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M233.1,356.45l-1.84-12.86a2.84,2.84,0,0,0,.84-2.25c-.14-1-1-1.31-1.88-.79a2.92,2.92,0,0,0-1.38,2.68,1.07,1.07,0,0,0,1.31,1L232,357.09Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M221.27,76.59l3.27,23a.56.56,0,0,0,.36.43l10.12,4.3,1.85,12.87a2.82,2.82,0,0,0-.84,2.24c.13,1,1,1.32,1.88.8a2.92,2.92,0,0,0,1.38-2.68,1.08,1.08,0,0,0-1.31-1l-1.8-12.57a.57.57,0,0,0-.36-.43L225.7,99.2,222.39,76Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M239.39,66.13l2.39,16.8a2.82,2.82,0,0,0-.84,2.24c.13,1,1,1.32,1.87.8a2.9,2.9,0,0,0,1.38-2.68,1.07,1.07,0,0,0-1.3-1l-2.38-16.79Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M230.33,71.36l3.27,23a.56.56,0,0,0,.36.43l10.12,4.3,2.54,17.7a2.82,2.82,0,0,0-.84,2.24,1.15,1.15,0,0,0,1.88.8,2.92,2.92,0,0,0,1.38-2.68,1.08,1.08,0,0,0-1.31-1l-2.49-17.4a.57.57,0,0,0-.36-.43L234.76,94l-3.31-23.25Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M272.93,246.31l-7-3-3.22-22.53a2.85,2.85,0,0,0,.83-2.24c-.13-1-1-1.32-1.87-.8a2.9,2.9,0,0,0-1.38,2.68,1.07,1.07,0,0,0,1.3,1l3.18,22.23a.59.59,0,0,0,.37.43l7.94,3.38Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M201.39,374.76l-6.18-43.18a.56.56,0,0,0-.36-.43l-20.57-8.73-7.56-52.85a.59.59,0,0,0-.37-.43L151,262.63l-5.3-37a2.82,2.82,0,0,0,.84-2.24,1.15,1.15,0,0,0-1.88-.8,2.9,2.9,0,0,0-1.38,2.68,1.08,1.08,0,0,0,1.3,1L149.85,263a.6.6,0,0,0,.37.44l15.34,6.51,7.57,52.85a.56.56,0,0,0,.36.43l20.56,8.73,6.23,43.47Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M192.33,380l-2-14.19a.54.54,0,0,0-.36-.43l-4.9-2.09-2.54-17.69a2.86,2.86,0,0,0,.84-2.25c-.13-1-1-1.32-1.87-.8a2.9,2.9,0,0,0-1.38,2.68,1.07,1.07,0,0,0,1.3,1l2.49,17.4a.58.58,0,0,0,.36.43l4.9,2.09,2.08,14.48Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M184.23,154.21l-10.13-4.3L168,107.33l-1.11.65,6,42.28a.56.56,0,0,0,.36.43l10.12,4.3,3.92,27.36a2.82,2.82,0,0,0-.84,2.24,1.15,1.15,0,0,0,1.88.8,2.9,2.9,0,0,0,1.38-2.68,1.08,1.08,0,0,0-1.3-1l-3.88-27.06A.6.6,0,0,0,184.23,154.21Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M212.79,148.18l-20.57-8.73-6.07-42.58-1.12.64,6,42.29a.56.56,0,0,0,.36.43L212,149l2.54,17.69a2.86,2.86,0,0,0-.84,2.25,1.15,1.15,0,0,0,1.88.8A2.92,2.92,0,0,0,217,167a1.09,1.09,0,0,0-1.31-1l-2.49-17.4A.56.56,0,0,0,212.79,148.18Z"
            style={{
              fill: "#fff",
            }}
          />
        </g>
      </g>
    </g>
    <g id="freepik--Android--inject-435">
      <g id="freepik--Cables--inject-435">
        <path
          d="M229.82,332.18a4.68,4.68,0,0,1-2.4-.65c-2.65-1.53-4.24-5.64-4.24-11,0-8.66,4.13-18.09,9.21-21h0a5.29,5.29,0,0,1,5.51-.27c2.66,1.54,4.25,5.64,4.25,11,0,8.66-4.13,18.1-9.21,21A6.22,6.22,0,0,1,229.82,332.18Zm3.12-31.71c-4.78,2.75-8.66,11.76-8.66,20.07,0,4.95,1.38,8.7,3.69,10a4.28,4.28,0,0,0,4.42-.27c4.77-2.76,8.66-11.77,8.66-20.08,0-5-1.38-8.7-3.7-10a4.24,4.24,0,0,0-4.41.28Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M220.67,310.88l-.15,0a.56.56,0,0,1-.38-.68,44.29,44.29,0,0,1,3.37-8.66.55.55,0,1,1,1,.51,43.3,43.3,0,0,0-3.28,8.44A.55.55,0,0,1,220.67,310.88Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M219,323a.55.55,0,0,1-.55-.55,43.81,43.81,0,0,1,.45-6.19.55.55,0,1,1,1.09.15,43.29,43.29,0,0,0-.44,6A.55.55,0,0,1,219,323Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M227.78,339.66h-.06c-4.15-.48-7.7-4.56-8.85-10.14a.55.55,0,1,1,1.07-.22c1.22,5.91,4.85,8.91,7.9,9.27a.55.55,0,0,1-.06,1.1Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M233.45,338a.55.55,0,0,1-.31-1,18.18,18.18,0,0,0,4.11-4,.55.55,0,0,1,.88.67,19.77,19.77,0,0,1-4.37,4.25A.5.5,0,0,1,233.45,338Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M241,328.52a.54.54,0,0,1-.25-.06.55.55,0,0,1-.24-.74,46,46,0,0,0,4.69-19.88c0-7.33-2.06-12.9-5.53-14.9-2-1.14-4.29-1-6.71.4a.55.55,0,0,1-.75-.21.56.56,0,0,1,.2-.75c2.78-1.6,5.48-1.74,7.81-.39,3.81,2.2,6.08,8.12,6.08,15.85a47,47,0,0,1-4.81,20.37A.55.55,0,0,1,241,328.52Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M170.48,271.67a2.68,2.68,0,0,1-1.4-.38c-1.52-.87-2.42-3.18-2.42-6.17,0-4.88,2.25-10,5.13-11.66h0a3.11,3.11,0,0,1,3.21-.15c1.52.88,2.42,3.18,2.42,6.18,0,4.87-2.25,10-5.13,11.66A3.63,3.63,0,0,1,170.48,271.67Zm3.11-17.74a2.57,2.57,0,0,0-1.3.4h0c-2.55,1.47-4.63,6.31-4.63,10.79,0,2.59.73,4.62,1.92,5.31a2.12,2.12,0,0,0,2.21-.15c2.55-1.47,4.63-6.32,4.63-10.79,0-2.6-.74-4.63-1.92-5.31A1.73,1.73,0,0,0,173.59,253.93Zm-1.55,0h0Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M165.49,260l-.14,0a.51.51,0,0,1-.35-.62,24.8,24.8,0,0,1,1.86-4.76.5.5,0,1,1,.89.46,22.86,22.86,0,0,0-1.78,4.57A.5.5,0,0,1,165.49,260Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M164.55,266.66a.5.5,0,0,1-.5-.5,25,25,0,0,1,.25-3.41.5.5,0,0,1,.57-.42.49.49,0,0,1,.42.56,23,23,0,0,0-.24,3.27A.5.5,0,0,1,164.55,266.66Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M169.37,275.76h-.06c-2.34-.28-4.36-2.57-5-5.7a.5.5,0,0,1,1-.21c.64,3.14,2.54,4.73,4.14,4.91a.5.5,0,0,1-.06,1Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M172.47,274.83a.48.48,0,0,1-.41-.21.5.5,0,0,1,.13-.7,9.65,9.65,0,0,0,2.2-2.15.5.5,0,1,1,.79.61,10.81,10.81,0,0,1-2.43,2.37A.46.46,0,0,1,172.47,274.83Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M176.58,269.67a.42.42,0,0,1-.22-.05.5.5,0,0,1-.23-.67,24.85,24.85,0,0,0,2.55-10.77c0-3.93-1.09-6.91-2.92-8a3.37,3.37,0,0,0-3.47.22.5.5,0,0,1-.5-.86,4.29,4.29,0,0,1,4.47-.22c2.14,1.23,3.42,4.54,3.42,8.83A26,26,0,0,1,177,269.4.51.51,0,0,1,176.58,269.67Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M210.17,246.85a2.78,2.78,0,0,1-1.4-.38c-1.52-.88-2.42-3.18-2.42-6.18,0-4.87,2.25-10,5.13-11.66h0a3.13,3.13,0,0,1,3.21-.14c1.51.87,2.42,3.18,2.42,6.17,0,4.88-2.26,10-5.13,11.66A3.64,3.64,0,0,1,210.17,246.85Zm3.11-17.75a2.67,2.67,0,0,0-1.3.4h0c-2.56,1.47-4.63,6.32-4.63,10.79,0,2.6.73,4.63,1.92,5.31a2.08,2.08,0,0,0,2.21-.15c2.55-1.47,4.63-6.31,4.63-10.79,0-2.59-.74-4.62-1.92-5.31A1.86,1.86,0,0,0,213.28,229.1Zm-1.55,0h0Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M205.18,235.21a.34.34,0,0,1-.14,0,.49.49,0,0,1-.35-.61,24.9,24.9,0,0,1,1.86-4.77.5.5,0,0,1,.89.46,23.19,23.19,0,0,0-1.78,4.58A.5.5,0,0,1,205.18,235.21Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M204.24,241.83a.5.5,0,0,1-.5-.5,25.13,25.13,0,0,1,.25-3.41.51.51,0,0,1,.57-.42.5.5,0,0,1,.42.57,22.77,22.77,0,0,0-.24,3.26A.5.5,0,0,1,204.24,241.83Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M209.06,250.93H209c-2.35-.28-4.36-2.57-5-5.7a.5.5,0,0,1,.39-.59.51.51,0,0,1,.59.39c.64,3.13,2.54,4.72,4.14,4.91a.5.5,0,0,1-.06,1Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M212.16,250a.5.5,0,0,1-.28-.91,10.3,10.3,0,0,0,2.2-2.15.5.5,0,0,1,.79.61,11,11,0,0,1-2.43,2.36A.49.49,0,0,1,212.16,250Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M216.27,244.85a.54.54,0,0,1-.22,0,.51.51,0,0,1-.23-.67,24.88,24.88,0,0,0,2.55-10.77c0-3.94-1.1-6.91-2.92-8a3.35,3.35,0,0,0-3.47.22.52.52,0,0,1-.69-.19.51.51,0,0,1,.19-.68,4.31,4.31,0,0,1,4.47-.22c2.14,1.24,3.42,4.54,3.42,8.84a26,26,0,0,1-2.65,11.21A.5.5,0,0,1,216.27,244.85Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M203.68,164.19a2.8,2.8,0,0,1-1.41-.37c-1.51-.88-2.42-3.19-2.42-6.18,0-4.88,2.26-10,5.13-11.66h0a3.12,3.12,0,0,1,3.22-.15c1.51.88,2.41,3.19,2.41,6.18,0,4.88-2.25,10-5.13,11.66A3.59,3.59,0,0,1,203.68,164.19Zm3.1-17.74a2.57,2.57,0,0,0-1.3.4h0c-2.55,1.47-4.63,6.31-4.63,10.79,0,2.59.74,4.63,1.92,5.31a2.1,2.1,0,0,0,2.21-.15c2.55-1.47,4.63-6.31,4.63-10.79,0-2.59-.73-4.63-1.91-5.31A1.79,1.79,0,0,0,206.78,146.45Zm-1.55,0h0Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M198.68,152.56l-.13,0a.49.49,0,0,1-.35-.61,24.63,24.63,0,0,1,1.85-4.77.5.5,0,0,1,.89.46,24.13,24.13,0,0,0-1.78,4.57A.49.49,0,0,1,198.68,152.56Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M197.75,159.18a.5.5,0,0,1-.5-.5,23.52,23.52,0,0,1,.25-3.41.5.5,0,0,1,1,.14,23,23,0,0,0-.24,3.27A.5.5,0,0,1,197.75,159.18Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M202.57,168.28h-.06c-2.35-.28-4.36-2.57-5-5.7a.5.5,0,0,1,.39-.59.49.49,0,0,1,.59.39c.65,3.13,2.55,4.72,4.14,4.9a.51.51,0,0,1,.44.56A.5.5,0,0,1,202.57,168.28Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M205.66,167.36a.5.5,0,0,1-.41-.22.51.51,0,0,1,.13-.7,9.44,9.44,0,0,0,2.2-2.15.5.5,0,1,1,.79.62,10.72,10.72,0,0,1-2.42,2.36A.52.52,0,0,1,205.66,167.36Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M209.77,162.2a.46.46,0,0,1-.22-.06.49.49,0,0,1-.22-.67,25,25,0,0,0,2.54-10.77c0-3.93-1.09-6.91-2.92-8a3.35,3.35,0,0,0-3.47.21.5.5,0,0,1-.5-.86,4.29,4.29,0,0,1,4.47-.22c2.14,1.24,3.42,4.54,3.42,8.83a25.87,25.87,0,0,1-2.65,11.22A.49.49,0,0,1,209.77,162.2Z"
          fill={theme.imageHighlight}
        />
        <g
          style={{
            opacity: 0.8,
          }}
        >
          <path
            d="M229.82,332.18a4.68,4.68,0,0,1-2.4-.65c-2.65-1.53-4.24-5.64-4.24-11,0-8.66,4.13-18.09,9.21-21h0a5.29,5.29,0,0,1,5.51-.27c2.66,1.54,4.25,5.64,4.25,11,0,8.66-4.13,18.1-9.21,21A6.22,6.22,0,0,1,229.82,332.18Zm3.12-31.71c-4.78,2.75-8.66,11.76-8.66,20.07,0,4.95,1.38,8.7,3.69,10a4.28,4.28,0,0,0,4.42-.27c4.77-2.76,8.66-11.77,8.66-20.08,0-5-1.38-8.7-3.7-10a4.24,4.24,0,0,0-4.41.28Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M220.67,310.88l-.15,0a.56.56,0,0,1-.38-.68,44.29,44.29,0,0,1,3.37-8.66.55.55,0,1,1,1,.51,43.3,43.3,0,0,0-3.28,8.44A.55.55,0,0,1,220.67,310.88Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M219,323a.55.55,0,0,1-.55-.55,43.81,43.81,0,0,1,.45-6.19.55.55,0,1,1,1.09.15,43.29,43.29,0,0,0-.44,6A.55.55,0,0,1,219,323Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M227.78,339.66h-.06c-4.15-.48-7.7-4.56-8.85-10.14a.55.55,0,1,1,1.07-.22c1.22,5.91,4.85,8.91,7.9,9.27a.55.55,0,0,1-.06,1.1Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M233.45,338a.55.55,0,0,1-.31-1,18.18,18.18,0,0,0,4.11-4,.55.55,0,0,1,.88.67,19.77,19.77,0,0,1-4.37,4.25A.5.5,0,0,1,233.45,338Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M241,328.52a.54.54,0,0,1-.25-.06.55.55,0,0,1-.24-.74,46,46,0,0,0,4.69-19.88c0-7.33-2.06-12.9-5.53-14.9-2-1.14-4.29-1-6.71.4a.55.55,0,0,1-.75-.21.56.56,0,0,1,.2-.75c2.78-1.6,5.48-1.74,7.81-.39,3.81,2.2,6.08,8.12,6.08,15.85a47,47,0,0,1-4.81,20.37A.55.55,0,0,1,241,328.52Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M170.48,271.67a2.68,2.68,0,0,1-1.4-.38c-1.52-.87-2.42-3.18-2.42-6.17,0-4.88,2.25-10,5.13-11.66h0a3.11,3.11,0,0,1,3.21-.15c1.52.88,2.42,3.18,2.42,6.18,0,4.87-2.25,10-5.13,11.66A3.63,3.63,0,0,1,170.48,271.67Zm3.11-17.74a2.57,2.57,0,0,0-1.3.4h0c-2.55,1.47-4.63,6.31-4.63,10.79,0,2.59.73,4.62,1.92,5.31a2.12,2.12,0,0,0,2.21-.15c2.55-1.47,4.63-6.32,4.63-10.79,0-2.6-.74-4.63-1.92-5.31A1.73,1.73,0,0,0,173.59,253.93Zm-1.55,0h0Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M165.49,260l-.14,0a.51.51,0,0,1-.35-.62,24.8,24.8,0,0,1,1.86-4.76.5.5,0,1,1,.89.46,22.86,22.86,0,0,0-1.78,4.57A.5.5,0,0,1,165.49,260Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M164.55,266.66a.5.5,0,0,1-.5-.5,25,25,0,0,1,.25-3.41.5.5,0,0,1,.57-.42.49.49,0,0,1,.42.56,23,23,0,0,0-.24,3.27A.5.5,0,0,1,164.55,266.66Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M169.37,275.76h-.06c-2.34-.28-4.36-2.57-5-5.7a.5.5,0,0,1,1-.21c.64,3.14,2.54,4.73,4.14,4.91a.5.5,0,0,1-.06,1Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M172.47,274.83a.48.48,0,0,1-.41-.21.5.5,0,0,1,.13-.7,9.65,9.65,0,0,0,2.2-2.15.5.5,0,1,1,.79.61,10.81,10.81,0,0,1-2.43,2.37A.46.46,0,0,1,172.47,274.83Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M176.58,269.67a.42.42,0,0,1-.22-.05.5.5,0,0,1-.23-.67,24.85,24.85,0,0,0,2.55-10.77c0-3.93-1.09-6.91-2.92-8a3.37,3.37,0,0,0-3.47.22.5.5,0,0,1-.5-.86,4.29,4.29,0,0,1,4.47-.22c2.14,1.23,3.42,4.54,3.42,8.83A26,26,0,0,1,177,269.4.51.51,0,0,1,176.58,269.67Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M210.17,246.85a2.78,2.78,0,0,1-1.4-.38c-1.52-.88-2.42-3.18-2.42-6.18,0-4.87,2.25-10,5.13-11.66h0a3.13,3.13,0,0,1,3.21-.14c1.51.87,2.42,3.18,2.42,6.17,0,4.88-2.26,10-5.13,11.66A3.64,3.64,0,0,1,210.17,246.85Zm3.11-17.75a2.67,2.67,0,0,0-1.3.4h0c-2.56,1.47-4.63,6.32-4.63,10.79,0,2.6.73,4.63,1.92,5.31a2.08,2.08,0,0,0,2.21-.15c2.55-1.47,4.63-6.31,4.63-10.79,0-2.59-.74-4.62-1.92-5.31A1.86,1.86,0,0,0,213.28,229.1Zm-1.55,0h0Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M205.18,235.21a.34.34,0,0,1-.14,0,.49.49,0,0,1-.35-.61,24.9,24.9,0,0,1,1.86-4.77.5.5,0,0,1,.89.46,23.19,23.19,0,0,0-1.78,4.58A.5.5,0,0,1,205.18,235.21Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M204.24,241.83a.5.5,0,0,1-.5-.5,25.13,25.13,0,0,1,.25-3.41.51.51,0,0,1,.57-.42.5.5,0,0,1,.42.57,22.77,22.77,0,0,0-.24,3.26A.5.5,0,0,1,204.24,241.83Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M209.06,250.93H209c-2.35-.28-4.36-2.57-5-5.7a.5.5,0,0,1,.39-.59.51.51,0,0,1,.59.39c.64,3.13,2.54,4.72,4.14,4.91a.5.5,0,0,1-.06,1Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M212.16,250a.5.5,0,0,1-.28-.91,10.3,10.3,0,0,0,2.2-2.15.5.5,0,0,1,.79.61,11,11,0,0,1-2.43,2.36A.49.49,0,0,1,212.16,250Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M216.27,244.85a.54.54,0,0,1-.22,0,.51.51,0,0,1-.23-.67,24.88,24.88,0,0,0,2.55-10.77c0-3.94-1.1-6.91-2.92-8a3.35,3.35,0,0,0-3.47.22.52.52,0,0,1-.69-.19.51.51,0,0,1,.19-.68,4.31,4.31,0,0,1,4.47-.22c2.14,1.24,3.42,4.54,3.42,8.84a26,26,0,0,1-2.65,11.21A.5.5,0,0,1,216.27,244.85Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M203.68,164.19a2.8,2.8,0,0,1-1.41-.37c-1.51-.88-2.42-3.19-2.42-6.18,0-4.88,2.26-10,5.13-11.66h0a3.12,3.12,0,0,1,3.22-.15c1.51.88,2.41,3.19,2.41,6.18,0,4.88-2.25,10-5.13,11.66A3.59,3.59,0,0,1,203.68,164.19Zm3.1-17.74a2.57,2.57,0,0,0-1.3.4h0c-2.55,1.47-4.63,6.31-4.63,10.79,0,2.59.74,4.63,1.92,5.31a2.1,2.1,0,0,0,2.21-.15c2.55-1.47,4.63-6.31,4.63-10.79,0-2.59-.73-4.63-1.91-5.31A1.79,1.79,0,0,0,206.78,146.45Zm-1.55,0h0Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M198.68,152.56l-.13,0a.49.49,0,0,1-.35-.61,24.63,24.63,0,0,1,1.85-4.77.5.5,0,0,1,.89.46,24.13,24.13,0,0,0-1.78,4.57A.49.49,0,0,1,198.68,152.56Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M197.75,159.18a.5.5,0,0,1-.5-.5,23.52,23.52,0,0,1,.25-3.41.5.5,0,0,1,1,.14,23,23,0,0,0-.24,3.27A.5.5,0,0,1,197.75,159.18Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M202.57,168.28h-.06c-2.35-.28-4.36-2.57-5-5.7a.5.5,0,0,1,.39-.59.49.49,0,0,1,.59.39c.65,3.13,2.55,4.72,4.14,4.9a.51.51,0,0,1,.44.56A.5.5,0,0,1,202.57,168.28Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M205.66,167.36a.5.5,0,0,1-.41-.22.51.51,0,0,1,.13-.7,9.44,9.44,0,0,0,2.2-2.15.5.5,0,1,1,.79.62,10.72,10.72,0,0,1-2.42,2.36A.52.52,0,0,1,205.66,167.36Z"
            style={{
              fill: "#fff",
            }}
          />
          <path
            d="M209.77,162.2a.46.46,0,0,1-.22-.06.49.49,0,0,1-.22-.67,25,25,0,0,0,2.54-10.77c0-3.93-1.09-6.91-2.92-8a3.35,3.35,0,0,0-3.47.21.5.5,0,0,1-.5-.86,4.29,4.29,0,0,1,4.47-.22c2.14,1.24,3.42,4.54,3.42,8.83a25.87,25.87,0,0,1-2.65,11.22A.49.49,0,0,1,209.77,162.2Z"
            style={{
              fill: "#fff",
            }}
          />
        </g>
        <path
          d="M223.67,241.64c-4.95,0-9-.29-11.36-1.08a2.84,2.84,0,0,1-1.87-1.84c-.33-1.29.3-2.83,1.93-2.33,4,1.8,38.74,4.38,59.94-16,7.34-7.06,12.86-15.14,18.2-22.94,12.15-17.76,23.61-34.52,53.13-33l-.2,4c-27.28-1.37-37.63,13.77-49.62,31.31-5.46,8-11.1,16.21-18.73,23.56C259.89,237.86,237.85,241.64,223.67,241.64Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M223.67,241.64c-4.95,0-9-.29-11.36-1.08a2.84,2.84,0,0,1-1.87-1.84c-.33-1.29.3-2.83,1.93-2.33,4,1.8,38.74,4.38,59.94-16,7.34-7.06,12.86-15.14,18.2-22.94,12.15-17.76,23.61-34.52,53.13-33l-.2,4c-27.28-1.37-37.63,13.77-49.62,31.31-5.46,8-11.1,16.21-18.73,23.56C259.89,237.86,237.85,241.64,223.67,241.64Z"
          style={{
            opacity: 0.4,
          }}
        />
        <path
          d="M247.27,238.42c2.06-.57,4.13-1.24,6.19-2,1.45-2.38,2.63-4.49,3.24-5.62-2,.91-4.06,1.71-6.1,2.41Z"
          style={{
            opacity: 0.15,
          }}
        />
        <path
          d="M205.8,156.89c-2.94-.19-2.49-4-1.37-4,.48,0,.95,0,1.43,0,21.17,0,37.16-13.63,54.88-46.6,15.79-29.38,30.36-41.31,52-42.53a2,2,0,1,1,.22,4c-20,1.14-33.66,12.47-48.69,40.43C250.65,133.52,234.13,156.89,205.8,156.89Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M205.8,156.89c-2.94-.19-2.49-4-1.37-4,.48,0,.95,0,1.43,0,21.17,0,37.16-13.63,54.88-46.6,15.79-29.38,30.36-41.31,52-42.53a2,2,0,1,1,.22,4c-20,1.14-33.66,12.47-48.69,40.43C250.65,133.52,234.13,156.89,205.8,156.89Z"
          style={{
            opacity: 0.35000000000000003,
          }}
        />
        <path
          d="M191.55,267a76.38,76.38,0,0,1-18.36-2.27,2.31,2.31,0,0,1-1.82-2c-.2-1.77.36-2.5,1.43-2.22,29.72,7.88,58.64-3.22,77.38-29.7,6.75-9.54,12.25-19.19,17.1-27.71,5.55-9.74,10.79-18.94,16.8-26.08,9.94-11.82,25.56-19.53,37.13-18.32a2,2,0,0,1,1.78,2.19,2,2,0,0,1-2.2,1.79c-10.16-1.06-24.65,6.21-33.65,16.91-5.78,6.87-10.69,15.5-16.38,25.49-4.9,8.6-10.45,18.34-17.31,28C237.89,255.11,215.64,267,191.55,267Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M191.55,267a76.38,76.38,0,0,1-18.36-2.27,2.31,2.31,0,0,1-1.82-2c-.2-1.77.36-2.5,1.43-2.22,29.72,7.88,58.64-3.22,77.38-29.7,6.75-9.54,12.25-19.19,17.1-27.71,5.55-9.74,10.79-18.94,16.8-26.08,9.94-11.82,25.56-19.53,37.13-18.32a2,2,0,0,1,1.78,2.19,2,2,0,0,1-2.2,1.79c-10.16-1.06-24.65,6.21-33.65,16.91-5.78,6.87-10.69,15.5-16.38,25.49-4.9,8.6-10.45,18.34-17.31,28C237.89,255.11,215.64,267,191.55,267Z"
          style={{
            opacity: 0.35000000000000003,
          }}
        />
        <path
          d="M319,67.11a6.83,6.83,0,1,1-6.83-6.83A6.83,6.83,0,0,1,319,67.11Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M324.9,159.13a6.83,6.83,0,1,1-6.83-6.83A6.83,6.83,0,0,1,324.9,159.13Z"
          fill={theme.imageHighlight}
        />
      </g>
      <g id="freepik--android--inject-435">
        <path
          d="M431.74,185.48c1.19,1.14,3.47,2.38,8.17,3.3s12.59,1.54,17.17.07,6.32-3.76,7.27-6.73.75-4.44,1.9-6.57c1.69-3,.92-4.6-2.29-3.59s-7.64,2.48-10.62,2.67a21.3,21.3,0,0,1-5.68-.45c-.75-.72,4.11-1.67,5.74-4.14s.5-3.77-.33-3.68-2.74,1.36-5.72,2.14-7.87,2-10.59,2.93-4.44,2-5.74,7.09S430.38,184.16,431.74,185.48Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M431.74,185.48c1.19,1.14,3.47,2.38,8.17,3.3s12.59,1.54,17.17.07,6.32-3.76,7.27-6.73.75-4.44,1.9-6.57c1.69-3,.92-4.6-2.29-3.59s-7.64,2.48-10.62,2.67a21.3,21.3,0,0,1-5.68-.45c-.75-.72,4.11-1.67,5.74-4.14s.5-3.77-.33-3.68-2.74,1.36-5.72,2.14-7.87,2-10.59,2.93-4.44,2-5.74,7.09S430.38,184.16,431.74,185.48Z"
          style={{
            fill: "#fff",
            opacity: 0.8,
          }}
        />
        <path
          d="M464.35,182.12c1-3,.75-4.44,1.9-6.57a4.52,4.52,0,0,0,.82-3c-.35,2-2.13,2.2-4.44,5.66-2.51,3.75-2.92,5.81-7.53,6.68-3.14.58-8.45.11-15.6-2.12L431,178.62c-1.26,5-.6,5.55.75,6.86,1.19,1.14,3.47,2.38,8.17,3.3s12.59,1.54,17.17.07S463.4,185.09,464.35,182.12Z"
          style={{
            opacity: 0.1,
          }}
        />
        <path
          d="M422.64,183.92s10.95,2.1,15.25,1.84c4.56-.27,7-3.73,4.66-6.46s-7.41-4.61-7.41-4.61l-9.64-3Z"
          fill={theme.text}
        />
        <path
          d="M382.39,170.22c-2.06,4.14,1.1,7.93,7.94,9.31s35.82,5.33,35.82,5.33c1.09.18,2.43-1.2,3.35-5.61.85-4.05,0-6.93-1.35-7.2,0,0-24.86-7.79-27.81-9C394.24,160.71,385.21,164.56,382.39,170.22Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M382.39,170.22c-2.06,4.14,1.1,7.93,7.94,9.31s35.82,5.33,35.82,5.33c1.09.18,2.43-1.2,3.35-5.61.85-4.05,0-6.93-1.35-7.2,0,0-24.86-7.79-27.81-9C394.24,160.71,385.21,164.56,382.39,170.22Z"
          style={{
            fill: "#fff",
            opacity: 0.8,
          }}
        />
        <path
          d="M428.81,181.83c-8.26-1.11-22.9-3.3-29.78-5.63-9.88-3.34-10-5.73-9.18-9l.77-3.73c-3.57,1.34-6.76,3.8-8.23,6.76-2.06,4.14,1.1,7.93,7.94,9.31s35.82,5.33,35.82,5.33C427,185,428,184.21,428.81,181.83Z"
          style={{
            opacity: 0.1,
          }}
        />
        <path
          d="M380.79,166.66l3.41,5.22s3,2.11,7.45-1c4.29-3,4.25-6.18,4.25-6.18L392.69,157Z"
          fill={theme.text}
        />
        <path
          d="M361.85,113.65c6.95-2.53,10.79,0,14.39,5.93,2.85,4.72,17.68,38.88,17.68,38.88,1.15,4.16-9.3,12.95-13.82,9.19,0,0-19.87-25-23.35-32.43C352.41,125.88,355.94,115.79,361.85,113.65Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M361.85,113.65c6.95-2.53,10.79,0,14.39,5.93,2.85,4.72,17.68,38.88,17.68,38.88,1.15,4.16-9.3,12.95-13.82,9.19,0,0-19.87-25-23.35-32.43C352.41,125.88,355.94,115.79,361.85,113.65Z"
          style={{
            fill: "#fff",
            opacity: 0.8,
          }}
        />
        <path
          d="M387.55,167.06c-2.67,1.54-5.57,2.15-7.45.59,0,0-19.86-25-23.34-32.44-.08-.17-.14-.35-.22-.52l2.84-1.61c0,.14.05.27.09.41,1.34,5.75,4.79,11.1,11.45,5.31a7.8,7.8,0,0,0,1.27-1.43C372.69,144.09,385.2,162.66,387.55,167.06Z"
          style={{
            opacity: 0.1,
          }}
        />
        <path
          d="M362.89,115.56c3.05-2.51,8.12-.88,9.79,3.64.83,2.25,4.05,14.53-1.76,19.6-6.65,5.8-10.11.45-11.46-5.3S357.21,119.1,362.89,115.56Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M362.89,115.56c3.05-2.51,8.12-.88,9.79,3.64.83,2.25,4.05,14.53-1.76,19.6-6.65,5.8-10.11.45-11.46-5.3S357.21,119.1,362.89,115.56Z"
          style={{
            opacity: 0.1,
          }}
        />
        <path
          d="M368.4,135.28c-2.48,2.18-6.12-.17-8-5s1.68-11.42,4.21-12.89c2.84-1.65,5.72.2,6.79,6.84C372.54,131.39,370.85,135.32,368.4,135.28Z"
          fill={theme.text}
        />
        <path
          d="M341.2,383.2a6.9,6.9,0,0,0,0,2.63c.31,1,5.24,2.39,7.9,3.15a23.79,23.79,0,0,1,9.44,6.07c2.76,2.94,6.9,5.3,13.85,5.28s9.71-2.59,10.36-3.4.37-2.88.37-2.88Z"
          fill={theme.text}
        />
        <path
          d="M342.44,363.56c1,5.57-.29,8.43-1.38,11.73a10.77,10.77,0,0,0,.14,7.91c3.3,2.58,10.45,2.95,14.93,6.16,2.4,1.71,6.27,6.8,11.47,6.23s10.16-7.67,10.16-7.67a42.68,42.68,0,0,1-10.8-7.78c-5.53-5.62-10.17-8.05-9.81-15.49Z"
          fill={theme.text}
        />
        <path
          d="M358.24,389c-3.92-3.21-10.25-6-10.05-8.44s-3.12-5.93-3.12-5.93-2.21-2.91,5.93-3.84c4.39-.5,5.93-1.66,6.42-2.62a13.51,13.51,0,0,1-.27-3.53l-14.71-1.09c1,5.57-.29,8.43-1.38,11.73a10.77,10.77,0,0,0,.14,7.91c3.3,2.58,10.45,2.95,14.93,6.16,1,.74,2.36,2.12,3.95,3.4A6.5,6.5,0,0,0,358.24,389Z"
          fill={theme.text}
        />
        <path
          d="M342.84,287.17c-3.6-.21-5.7,4.68-6.19,18-.44,11.89,5.36,58.82,6,62.25.49,2.62,14.64,2.51,14.83-.78.33-5.47,6.3-63.38,6.85-70s.87-8.07-2.51-9.13S342.84,287.17,342.84,287.17Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M342.84,287.17c-3.6-.21-5.7,4.68-6.19,18-.44,11.89,5.36,58.82,6,62.25.49,2.62,14.64,2.51,14.83-.78.33-5.47,6.3-63.38,6.85-70s.87-8.07-2.51-9.13S342.84,287.17,342.84,287.17Z"
          style={{
            fill: "#fff",
            opacity: 0.8,
          }}
        />
        <path
          d="M361.82,287.55c-3.39-1.05-19-.38-19-.38-3.6-.21-5.7,4.68-6.19,18-.44,11.89,5.36,58.82,6,62.25.15.8,1.59,1.35,3.51,1.63-.83-10.33-2.74-35.18-2.74-44.36,0-11.73-.26-31.24,6.32-25.52,6.12,5.34,11.69,3.26,14.39-.31.09-1,.16-1.74.2-2.22C364.88,290.05,365.2,288.61,361.82,287.55Z"
          style={{
            opacity: 0.1,
          }}
        />
        <path
          d="M341.2,277.55l.9,11.48c0,1.83,3.65,5.26,11.78,5.12,7-.12,8.84-4,8.84-4l2.21-16.09Z"
          fill={theme.text}
        />
        <path
          d="M365.61,179.43c2.47,5.06,4.82,12.44,4.71,47.28s-4.71,54.22-4.71,54.22c-2,6.43-24.15,5.9-25.3.55l-13.09-69.76C325.63,195.29,353.08,153.75,365.61,179.43Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M365.61,179.43c2.47,5.06,4.82,12.44,4.71,47.28s-4.71,54.22-4.71,54.22c-2,6.43-24.15,5.9-25.3.55l-13.09-69.76C325.63,195.29,353.08,153.75,365.61,179.43Z"
          style={{
            fill: "#fff",
            opacity: 0.8,
          }}
        />
        <path
          d="M327.22,211.72l13.09,69.76c.87,4,13.61,5.32,20.72,3a2,2,0,0,0-.07-.35c-1.76-6.05-8.38.15-9.42-1.6s-2.46-35.33-3.45-46.55c-1.32-14.83,8.45-22.09,11.76-36.38a127.75,127.75,0,0,0,2.8-24.71C349.24,159.67,325.75,196.48,327.22,211.72Z"
          style={{
            opacity: 0.1,
          }}
        />
        <path
          d="M358.4,175.17c3.88.88,8.19,8.62,7.48,19.16s-6.27,25.8-18.5,22.79S340.71,170.42,358.4,175.17Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M358.4,175.17c3.88.88,8.19,8.62,7.48,19.16s-6.27,25.8-18.5,22.79S340.71,170.42,358.4,175.17Z"
          style={{
            opacity: 0.1,
          }}
        />
        <path
          d="M356.83,184.76c3.31.76,7.43,3.33,5,13.79-2.05,8.75-4.72,13-11.77,11.43C339.59,207.66,341.79,180.73,356.83,184.76Z"
          fill={theme.text}
        />
        <path
          d="M350.05,386.6c4.21.31,5.94.46,10.09,2.76s7.13-4.23,13.56-4a28.17,28.17,0,0,1,7.39,3.2c1.66,1.13,2.28,2.55,2,5.45a10.92,10.92,0,0,1-7.9,3.81c-8.75.75-13.17-2.8-16.67-5.77S353.41,387.7,350.05,386.6Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M350.05,386.6c4.21.31,5.94.46,10.09,2.76s7.13-4.23,13.56-4a28.17,28.17,0,0,1,7.39,3.2c1.66,1.13,2.28,2.55,2,5.45a10.92,10.92,0,0,1-7.9,3.81c-8.75.75-13.17-2.8-16.67-5.77S353.41,387.7,350.05,386.6Z"
          style={{
            fill: "#fff",
            opacity: 0.8,
          }}
        />
        <path
          d="M371.5,394.54c-8.57-.21-12.46-4.42-15.89-7.18a26.84,26.84,0,0,0-5.56-.76c3.36,1.1,5,2.53,8.5,5.49s7.92,6.52,16.67,5.77a10.92,10.92,0,0,0,7.9-3.81c.25-2.9-.37-4.32-2-5.45C383.54,391.41,380.06,394.75,371.5,394.54Z"
          style={{
            opacity: 0.1,
          }}
        />
        <path
          d="M347.33,376.48c-.54,2.85-2.43,5.2-5,4.72a5,5,0,0,1-3.62-6c.54-2.85,3-4.78,5.56-4.3S347.86,373.62,347.33,376.48Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M347.33,376.48c.39-2.08-.06-3.83-1.29-4.83,1.24,2,.23,6.14-3.4,6.18-3.26,0-3.87-2.43-3.55-3.82a6.24,6.24,0,0,0-.35,1.16,5,5,0,0,0,3.62,6C344.9,381.68,346.79,379.33,347.33,376.48Z"
          style={{
            opacity: 0.15,
          }}
        />
        <path
          d="M351.42,290.14c.36-5.63,3.45-10.61,8.45-10.29s8.77,5.13,8.41,10.76-4.7,9.93-9.7,9.61S351.07,295.76,351.42,290.14Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M358.67,295.55c-5.36-4.09-3.3-12.79-.07-15.65-4.25.53-6.85,5.11-7.18,10.24-.35,5.62,2.16,9.76,7.16,10.08a8.93,8.93,0,0,0,8.15-4.59A6.23,6.23,0,0,1,358.67,295.55Z"
          style={{
            opacity: 0.15,
          }}
        />
        <path
          d="M358.66,182.22s3.12,9.52-2,21.86c-5.51,13.27-12.16,17.48-18.9,16.82s-14.41-7.48-17.55-13.7c-4.52-8.93-3.69-14.61-2.82-18.75A47.52,47.52,0,0,1,321,178.2Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M358.66,182.22s3.12,9.52-2,21.86c-5.51,13.27-12.16,17.48-18.9,16.82s-14.41-7.48-17.55-13.7c-4.52-8.93-3.69-14.61-2.82-18.75A47.52,47.52,0,0,1,321,178.2Z"
          style={{
            fill: "#fff",
            opacity: 0.7000000000000001,
          }}
        />
        <path
          d="M351.78,213.14c-2.77,1.65-6.36,2.28-11,1.36-8.55-1.68-11.79-14.41-12.55-20s-1.36-11.39,4.44-13.35l1.37-1.54-13-1.39a47.52,47.52,0,0,0-3.66,10.25c-.87,4.14-1.7,9.82,2.82,18.75,3.14,6.22,10.79,13,17.55,13.7C342.6,221.38,347.41,219.3,351.78,213.14Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M351.78,213.14c-2.77,1.65-6.36,2.28-11,1.36-8.55-1.68-11.79-14.41-12.55-20s-1.36-11.39,4.44-13.35l1.37-1.54-13-1.39a47.52,47.52,0,0,0-3.66,10.25c-.87,4.14-1.7,9.82,2.82,18.75,3.14,6.22,10.79,13,17.55,13.7C342.6,221.38,347.41,219.3,351.78,213.14Z"
          style={{
            opacity: 0.05,
          }}
        />
        <path
          d="M319.47,161.87c2.44,4.64,3.33,11.73,1.56,16.33,0,0,12.6,12.52,24.6,11.81a15.67,15.67,0,0,0,13-7.79l3.37-31.5s-5.51-15.86-15.8-15.21S319.47,161.87,319.47,161.87Z"
          fill={theme.text}
        />
        <path
          d="M323.54,180.44h0c4.27,3.57,13.33,10.09,22.09,9.57a16.61,16.61,0,0,0,5.87-1.39c-5.75.24-12.57-2.81-15.07-6.05-2.61-3.4-3.69-7.63-3.35-13.66.12-1.35,1.71-22.62,3-27.55-7.09,6.55-14,16.61-16,19.62l0,.05-.32.49,0,0-.07.11-.07.11,0,0,0,.06a21.68,21.68,0,0,1,1.8,4.92,23.62,23.62,0,0,1,.56,3.26,22.42,22.42,0,0,1,.12,3.26,16.75,16.75,0,0,1-.62,4c-.09.31-.19.61-.3.89C321,178.2,322,179.12,323.54,180.44Z"
          fill={theme.text}
        />
        <path
          d="M346.23,135.51a12,12,0,0,0-5.41,2.1c4.94.19,6.16,8,7.92,14.54,2,7.53,1.94,5.81,10.86,7.38l1.4.87,1-9.68S356.52,134.86,346.23,135.51Z"
          fill={theme.text}
        />
        <path
          d="M315,110.82c-9.65,2.23-14.42,3.93-13.35,13.93S310.12,152.49,315,159c5.07,6.77,4.78,7.89,10.59,6.26,7.35-2.06,16.1-6.37,17-8.93s.34-16.62,4.54-16.7,4.7,14.29,5.66,16.31,7.88,5.79,9.35,5,7-15.21,7.14-27.79c.14-15-2.55-18.48-12.14-21.14Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M315,110.82c-9.65,2.23-14.42,3.93-13.35,13.93S310.12,152.49,315,159c5.07,6.77,4.78,7.89,10.59,6.26,7.35-2.06,16.1-6.37,17-8.93s.34-16.62,4.54-16.7,4.7,14.29,5.66,16.31,7.88,5.79,9.35,5,7-15.21,7.14-27.79c.14-15-2.55-18.48-12.14-21.14Z"
          style={{
            fill: "#fff",
            opacity: 0.7000000000000001,
          }}
        />
        <path
          d="M321.42,111l-6.38-.18c-9.65,2.23-14.42,3.93-13.35,13.93S310.12,152.49,315,159c5.07,6.77,4.78,7.89,10.59,6.26a61,61,0,0,0,7.82-2.82c-4.68.15-9.19,0-14.84-11.3s-7.07-20.75-6.75-28.14C312.15,116.28,314.73,113.45,321.42,111Z"
          style={{
            opacity: 0.1,
          }}
        />
        <path
          d="M305.4,115.74c4.31-2.95,7.92-.33,10.15,8.47,1.61,6.36.71,15.75-3.77,17.49-4.22,1.64-6.07-3.58-8.43-10.82C302,126.86,301.08,118.7,305.4,115.74Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M305.4,115.74c4.31-2.95,7.92-.33,10.15,8.47,1.61,6.36.71,15.75-3.77,17.49-4.22,1.64-6.07-3.58-8.43-10.82C302,126.86,301.08,118.7,305.4,115.74Z"
          style={{
            opacity: 0.1,
          }}
        />
        <path
          d="M345.75,117.85l-1,.22a110,110,0,0,1,2.32,21.61h.06a1.91,1.91,0,0,1,.94.25A112,112,0,0,0,345.75,117.85Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M323.73,91.51S325,107,325,107.65s-9.91,3.17-9.91,3.17,7.26-.33,17.49,4.15a42.38,42.38,0,0,1,9.78,6.35,3.87,3.87,0,0,0,5.71-.79c.61-.92,1.28-1.88,1.93-2.72a25.57,25.57,0,0,1,7.21-5.81s-13.05-5-13.05-5.48l-.77-9.92Z"
          fill={theme.text}
        />
        <path
          d="M334.07,217.1c2.37-1.19,1.68-12.13-.19-18.62-2.84-9.89-8-14.4-11.86-13.68s-3.79,10.71-2.94,14.42C320.53,205.53,327.71,217.59,334.07,217.1Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M334.07,217.1c2.37-1.19,1.68-12.13-.19-18.62-2.84-9.89-8-14.4-11.86-13.68s-3.79,10.71-2.94,14.42C320.53,205.53,327.71,217.59,334.07,217.1Z"
          style={{
            opacity: 0.1,
          }}
        />
        <circle
          cx={335.01}
          cy={70.35}
          r={25.86}
          transform="translate(189.57 380.23) rotate(-76.72)"
          fill={theme.text}
        />
        <path
          d="M343.8,102.53l-.32-4.25-.27-5.6s-5.28-1.64-18.84-6.29c-9.93-3.4-14.92-13.65-13.9-24.19A25.85,25.85,0,0,0,323.9,93.7c.34,4.29,1.05,13.42,1.05,14,0,0,1.79-1.15,5.89-.77s8,3.68,6.3-1.29C335.66,101.21,342.2,102.22,343.8,102.53Z"
          fill={theme.text}
        />
        <path
          d="M343.43,46c-11.58,0-17.8,7.7-19.81,18.24-1.29,6.8-.71,22.68,5.39,30.33,3.22,4,18.12,8.77,24.38,7,6.91-1.94,8-11,8.61-20.1a60.33,60.33,0,0,0-1.88-20C358,52,350,46.47,343.43,46Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M343.43,46c-11.58,0-17.8,7.7-19.81,18.24-1.29,6.8-.71,22.68,5.39,30.33,3.22,4,18.12,8.77,24.38,7,6.91-1.94,8-11,8.61-20.1a60.33,60.33,0,0,0-1.88-20C358,52,350,46.47,343.43,46Z"
          style={{
            fill: "#fff",
            opacity: 0.8,
          }}
        />
        <path
          d="M362,80.8a7.63,7.63,0,0,1-1.51,1c-8-.7-10-6.49-10.07-6.79,0-.57-.58-9.49-2.31-14.06a19.5,19.5,0,0,0,1.86-.64c3.31-1.32,5.46-3.23,6.36-5.67a6.92,6.92,0,0,0,.27-.93c-.13-.18-.27-.34-.4-.51a7.06,7.06,0,0,1-.34,1.27c-.85,2.3-2.9,4.11-6.08,5.37-10,4-19.69-.49-23.3-4.14l-.24.46c2.74,2.68,8.57,5.74,15.42,5.74a22.54,22.54,0,0,0,6-.81c1.7,4.44,2.26,13.47,2.28,13.94-.58,2.25-4.16,8.32-13.78,9.91a19.73,19.73,0,0,1-7.94-6.73l-.42.27A20.25,20.25,0,0,0,336,85.44c.23.3,1.81,2.48,2.33,7.47,0,.35.07.7.11,1a18.94,18.94,0,0,0,1.24,6.13l.68.21c-.94-1.5-1.18-3.93-1.43-6.38,0-.35-.07-.7-.1-1.06-.47-4.4-1.71-6.65-2.24-7.44,8.87-1.59,12.65-6.94,13.66-9.59.76,1.66,3.39,6,10.33,6.53h.07l.07,0a9.81,9.81,0,0,0,1.31-.85v-.09C362,81.19,362,81,362,80.8Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M353.39,101.55a7.84,7.84,0,0,0,1.4-.55c-6,1.07-13-1-19.5-4.8s-7.81-8.16-9.36-17.53.33-22.4,4.82-28.28c-3.72,3.27-6.05,8.12-7.13,13.81-1.29,6.8-.71,22.68,5.39,30.33C332.23,98.56,347.13,103.3,353.39,101.55Z"
          style={{
            opacity: 0.1,
          }}
        />
        <path
          d="M329.93,82.2c0-4.17-2.93-8.56-6.54-9.81a4.65,4.65,0,0,0-4.68.66c-1.66.79-2.75,2.66-2.75,5.2,0,4.16,2.92,8.56,6.53,9.81a4.67,4.67,0,0,0,4.69-.67C328.84,86.6,329.93,84.74,329.93,82.2Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M329.93,82.2c0-4.17-2.93-8.56-6.54-9.81a4.65,4.65,0,0,0-4.68.66c-1.66.79-2.75,2.66-2.75,5.2,0,4.16,2.92,8.56,6.53,9.81a4.67,4.67,0,0,0,4.69-.67C328.84,86.6,329.93,84.74,329.93,82.2Z"
          style={{
            opacity: 0.15,
          }}
        />
        <path
          d="M322.49,73c3.61,1.25,6.54,5.65,6.54,9.82s-2.93,6.53-6.54,5.28S316,82.41,316,78.25,318.88,71.71,322.49,73Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M324.37,86.39a3.71,3.71,0,0,1-1.22-.22c-2.82-1-5.19-4.6-5.19-7.92,0-2.2,1-3.62,2.65-3.62a3.72,3.72,0,0,1,1.23.22c2.81,1,5.19,4.61,5.19,7.93C327,85,326,86.39,324.37,86.39Z"
          style={{
            opacity: 0.15,
          }}
        />
        <path
          d="M321.84,74.85a3.72,3.72,0,0,0-1.23-.22,2.13,2.13,0,0,0-.25,0,4.61,4.61,0,0,0-.61,2.44c0,3.31,2.38,6.94,5.2,7.92a3.67,3.67,0,0,0,1.22.22,1.9,1.9,0,0,0,.25,0,4.5,4.5,0,0,0,.61-2.43C327,79.46,324.65,75.83,321.84,74.85Z"
          style={{
            opacity: 0.15,
          }}
        />
        <path
          d="M337.68,68.88c-2.34-.15-4-.4-4.81.34-1.12,1-.79,2.55-.23,5.78.33,1.85.7,3.67,2.37,4.94,1.9,1.44,6.05,2.7,11.82,2.7,6.52,0,11.91-1.26,15.33-6.43a45.67,45.67,0,0,0-1.22-11.47,22.15,22.15,0,0,1-7.55,3.32C347.61,69.37,344.14,69.3,337.68,68.88Z"
          fill={theme.text}
        />
        <ellipse
          cx={341.71}
          cy={76}
          rx={2.03}
          ry={2.42}
          transform="translate(-7.07 46.04) rotate(-7.63)"
          fill={theme.imageHighlight}
        />
        <path
          d="M359.91,73.73a1.91,1.91,0,1,1-2-2.19A2.11,2.11,0,0,1,359.91,73.73Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M283.79,264c-2.21-2.85-7.28-1.22-17.67,7.2-9.25,7.49-31.42,32.58-33.87,35.07A17.65,17.65,0,0,0,227.46,319c.1,5.87,4.66,7.37,6.23,6.44,6-3.52,51.71-35.05,57.07-39s6.65-4.65,5.22-7.89S283.79,264,283.79,264Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M283.79,264c-2.21-2.85-7.28-1.22-17.67,7.2-9.25,7.49-31.42,32.58-33.87,35.07A17.65,17.65,0,0,0,227.46,319c.1,5.87,4.66,7.37,6.23,6.44,6-3.52,51.71-35.05,57.07-39s6.65-4.65,5.22-7.89S283.79,264,283.79,264Z"
          style={{
            fill: "#fff",
            opacity: 0.8,
          }}
        />
        <path
          d="M277.75,271.17c.8,5.33,6.72,9.1-12.15,23.35-11.52,8.71-27.24,19.78-37.73,27.09,1.16,3.69,4.52,4.6,5.82,3.83,6-3.52,51.71-35.05,57.07-39s6.65-4.65,5.22-7.89c-1.21-2.75-9.1-11.26-11.5-13.82l-1.61-.77C277.36,263.66,277,265.85,277.75,271.17Z"
          style={{
            opacity: 0.1,
          }}
        />
        <path
          d="M285.62,258.35l-5.47,6.32c-1.06,1.42-.57,5,3.69,10s9.66,7,11.1,5.73l8.29-8.31Z"
          fill={theme.text}
        />
        <path
          d="M318.07,192.36a70.25,70.25,0,0,1,7.42-2.66c2.56-.63,4.31,5.17,5,7.09,2.16,6,2.59,13.51,1.73,14.33-2.09,2-6.59,3.25-6.59,3.25Z"
          fill={theme.text}
        />
        <path
          d="M313.84,173.6c5.86,0,14.88,23.87,15.89,34.22s2.75,16.91-7.7,37.49c-11,21.74-19.95,29.4-19.95,29.4-4.08,2.35-20.26-10.72-19.16-16.4,0,0,9.07-30.77,12.61-44.84S304.14,172.36,313.84,173.6Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M313.84,173.6c5.86,0,14.88,23.87,15.89,34.22s2.75,16.91-7.7,37.49c-11,21.74-19.95,29.4-19.95,29.4-4.08,2.35-20.26-10.72-19.16-16.4,0,0,9.07-30.77,12.61-44.84S304.14,172.36,313.84,173.6Z"
          style={{
            fill: "#fff",
            opacity: 0.8,
          }}
        />
        <path
          d="M323.11,185.7c-3-6.74-6.49-12.1-9.27-12.1-9.7-1.24-14.76,25.79-18.31,39.87s-12.61,44.84-12.61,44.84c-.95,4.91,11,15.32,16.89,16.55,1.35-1.49,2.38-3.1,2.43-4.56.16-4.41-9.18-4.28-9.68-6.55s8.25-29.34,13.8-51.31S318.13,180.17,323.11,185.7Z"
          style={{
            opacity: 0.1,
          }}
        />
        <path
          d="M288.21,272.88c3.44-4.47,8.79-6.87,12.76-3.81s4.4,9.16,1,13.63-9.45,5.6-13.42,2.54S284.77,277.34,288.21,272.88Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M291.45,281.48c-2.3-4.45,0-11.93,7.38-13.5-3.6-1.08-7.77,1.19-10.62,4.9-3.44,4.46-3.67,9.3.3,12.36,3.49,2.69,8.56,2.13,12.07-1.08C298.43,284.8,293.76,285.92,291.45,281.48Z"
          style={{
            opacity: 0.15,
          }}
        />
        <path
          d="M259,209.65c-.82,1.43-1.46,3.95-1.19,8.73S259.46,231,262,235s5.2,5.19,8.32,5.38,4.48-.37,6.82.22c3.36.89,4.69-.24,2.92-3.11s-4.29-6.79-5.21-9.62a21.57,21.57,0,0,1-1-5.62c.5-.91,2.63,3.56,5.42,4.53s3.78-.44,3.49-1.22-2-2.32-3.49-5-3.86-7.13-5.45-9.54-3-3.81-8.29-3.81S260,208,259,209.65Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M259,209.65c-.82,1.43-1.46,3.95-1.19,8.73S259.46,231,262,235s5.2,5.19,8.32,5.38,4.48-.37,6.82.22c3.36.89,4.69-.24,2.92-3.11s-4.29-6.79-5.21-9.62a21.57,21.57,0,0,1-1-5.62c.5-.91,2.63,3.56,5.42,4.53s3.78-.44,3.49-1.22-2-2.32-3.49-5-3.86-7.13-5.45-9.54-3-3.81-8.29-3.81S260,208,259,209.65Z"
          style={{
            fill: "#fff",
            opacity: 0.8,
          }}
        />
        <path
          d="M262,235c2.55,4.07,5.2,5.19,8.32,5.38s4.48-.37,6.82.22c1.87.49,3.11.36,3.54-.34-1.45,1-3.09-.39-4.71-1.88s-6.26-1.15-7.68-1.95c-1.86-1.05-4.43-2.22-5.76-9.42s1.62-8,3.69-14.08l-.18-5.73h-.47c-5.27,0-5.62.77-6.56,2.42-.82,1.43-1.46,3.95-1.19,8.73S259.46,231,262,235Z"
          style={{
            opacity: 0.1,
          }}
        />
        <path
          d="M306.61,118.67c2.93-1.53,5.24,2.39,5.93,7.52s.31,8.68-2.37,9.87c-3.94,1.76-9.08-.5-10.12-5.88C299.17,125.6,301.89,121.42,306.61,118.67Z"
          fill={theme.text}
        />
        <path
          d="M258.29,200.44s.67,11.14,2,15.24c1.39,4.34,5.34,5.84,7.41,2.92s2.64-8.32,2.64-8.32l.51-10.08Z"
          fill={theme.text}
        />
        <path
          d="M261.62,158.06c-4.51-1-7.4,3-7.06,10s3.48,36,3.48,36c.14,1,2.43,1.85,6.52,1.73s6.41-2.05,6.47-2.87c0,0,1.53-26.1,1.93-29.24C273.77,167.19,267.81,159.39,261.62,158.06Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M261.62,158.06c-4.51-1-7.4,3-7.06,10s3.48,36,3.48,36c.14,1,2.43,1.85,6.52,1.73s6.41-2.05,6.47-2.87c0,0,1.53-26.1,1.93-29.24C273.77,167.19,267.81,159.39,261.62,158.06Z"
          style={{
            fill: "#fff",
            opacity: 0.8,
          }}
        />
        <path
          d="M273,171.76c-.4-6-5.78-12.5-11.37-13.7-4.51-1-7.4,3-7.06,10s3.48,36,3.48,36c.12.9,1.87,1.63,5,1.73-.42-4.19-.57-9.81-.87-14.76-.73-11.73-3-21.73,2.38-18.76C268.56,174.49,272,173.8,273,171.76Z"
          style={{
            opacity: 0.1,
          }}
        />
        <path
          d="M264.69,155.63l-4.23,4.59s-1.3,3.42,2.83,7c4,3.41,7,2.59,7,2.59l6.7-5Z"
          fill={theme.text}
        />
        <path
          d="M305.46,117.36c4.72,4.15,6.27,18.61,2.71,22.81s-32.55,26.67-32.55,26.67c-3.75,2.14-14.85-5.82-12.33-11.13,0,0,20.4-24.29,25.68-30.63S300.73,113.21,305.46,117.36Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M305.46,117.36c4.72,4.15,6.27,18.61,2.71,22.81s-32.55,26.67-32.55,26.67c-3.75,2.14-14.85-5.82-12.33-11.13,0,0,20.4-24.29,25.68-30.63S300.73,113.21,305.46,117.36Z"
          style={{
            fill: "#fff",
            opacity: 0.8,
          }}
        />
        <path
          d="M305.46,117.36c-4.73-4.15-11.22,1.39-16.49,7.72s-25.68,30.63-25.68,30.63c-.92,1.94,0,4.24,1.68,6.26,1.89-2.75,6.42-8.77,16.25-19.44,11.26-12.2,20.61-21.09,26.29-22.38A9.62,9.62,0,0,0,305.46,117.36Z"
          style={{
            opacity: 0.1,
          }}
        />
      </g>
    </g>
  </svg>
    );
  }
}